// @ts-nocheck
/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';


export const HOST="Specify host"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
export const apiSubscriptionSSE = (options: chainOptions) => (query: string, variables?: Record<string, unknown>) => {
  const url = options[0];
  const fetchOptions = options[1] || {};

  let abortController: AbortController | null = null;
  let reader: ReadableStreamDefaultReader<Uint8Array> | null = null;
  let onCallback: ((args: unknown) => void) | null = null;
  let errorCallback: ((args: unknown) => void) | null = null;
  let openCallback: (() => void) | null = null;
  let offCallback: ((args: unknown) => void) | null = null;
  let isClosing = false; // Flag to track intentional close

  const startStream = async () => {
    try {
      abortController = new AbortController();

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'text/event-stream',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          ...fetchOptions.headers,
        },
        body: JSON.stringify({ query, variables }),
        signal: abortController.signal,
        ...fetchOptions,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (openCallback) {
        openCallback();
      }

      reader = response.body?.getReader() || null;
      if (!reader) {
        throw new Error('No response body');
      }

      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          if (offCallback) {
            offCallback({ data: null, code: 1000, reason: 'Stream completed' });
          }
          break;
        }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const data = line.slice(6);
              const parsed = JSON.parse(data);

              if (parsed.errors) {
                if (errorCallback) {
                  errorCallback({ data: parsed.data, errors: parsed.errors });
                }
              } else if (onCallback && parsed.data) {
                onCallback(parsed.data);
              }
            } catch {
              if (errorCallback) {
                errorCallback({ errors: ['Failed to parse SSE data'] });
              }
            }
          }
        }
      }
    } catch (err: unknown) {
      const error = err as Error;
      // Don't report errors if we're intentionally closing (AbortError) or during cleanup
      if (error.name !== 'AbortError' && !isClosing && errorCallback) {
        errorCallback({ errors: [error.message || 'Unknown error'] });
      }
    }
  };

  return {
    on: (e: (args: unknown) => void) => {
      onCallback = e;
    },
    off: (e: (args: unknown) => void) => {
      offCallback = e;
    },
    error: (e: (args: unknown) => void) => {
      errorCallback = e;
    },
    open: (e?: () => void) => {
      if (e) {
        openCallback = e;
      }
      startStream();
    },
    close: () => {
      isClosing = true; // Mark as intentionally closing to suppress error callbacks
      if (abortController) {
        abortController.abort();
      }
      if (reader) {
        // Wrap in try-catch to suppress AbortError during cleanup
        reader.cancel().catch(() => {
          // Ignore cancel errors - stream may already be closed
        });
      }
    },
  };
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

type UnionOverrideKeys<T, U> = Omit<T, keyof U> & U;

export const Thunder =
  <SCLR extends ScalarDefinition>(fn: FetchFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    return fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (options?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: options.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, UnionOverrideKeys<SCLR, OVERRIDESCLR>>>;
  };

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export type SubscriptionToGraphQLSSE<Z, T, SCLR extends ScalarDefinition> = {
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: (fn?: () => void) => void;
  close: () => void;
};

export const SubscriptionThunderSSE =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ) as SubscriptionToGraphQLSSE<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };
export const SubscriptionSSE = (...options: chainOptions) => SubscriptionThunderSSE(apiSubscriptionSSE(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z,
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

type BaseSymbol = number | string | undefined | boolean | null;

type ScalarsSelector<T, V> = {
  [X in Required<{
    [P in keyof T]: P extends keyof V
      ? V[P] extends Array<any> | undefined
        ? never
        : T[P] extends BaseSymbol | Array<BaseSymbol>
        ? P
        : never
      : never;
  }>[keyof T]]: true;
};

export const fields = <T extends keyof ModelTypes>(k: T) => {
  const t = ReturnTypes[k];
  const fnType = k in AllTypesProps ? AllTypesProps[k as keyof typeof AllTypesProps] : undefined;
  const hasFnTypes = typeof fnType === 'object' ? fnType : undefined;
  const o = Object.fromEntries(
    Object.entries(t)
      .filter(([k, value]) => {
        const isFunctionType = hasFnTypes && k in hasFnTypes && !!hasFnTypes[k as keyof typeof hasFnTypes];
        if (isFunctionType) return false;
        const isReturnType = ReturnTypes[value as string];
        if (!isReturnType) return true;
        if (typeof isReturnType !== 'string') return false;
        if (isReturnType.startsWith('scalar.')) {
          return true;
        }
        return false;
      })
      .map(([key]) => [key, true as const]),
  );
  return o as ScalarsSelector<ModelTypes[T], T extends keyof ValueTypes ? ValueTypes[T] : never>;
};

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string, variables?: Record<string, unknown>) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super(response.errors?.[0]?.message || 'GraphQL Response Error');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? (typeof Ops)[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  _type: T,
  _field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S extends Array<infer R>
  ? Array<IsScalar<R, SCLR>>
  : S;

type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer _R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <Z extends V>(
  t: Z & {
    [P in keyof Z]: P extends keyof V ? Z[P] : never;
  },
) => Z;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type ComposableSelector<T extends keyof ValueTypes> = ReturnType<SelectionFunction<ValueTypes[T]>>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = never
export type ScalarCoders = {
	DateTime?: ScalarResolver;
	ID?: ScalarResolver;
}
type ZEUS_UNIONS = GraphQLTypes["AuthType"]

export type ValueTypes = {
    ["Permissions"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:ValueTypes["Role"],
		__typename?: boolean | `@${string}`,
	['...on Permissions']?: Omit<ValueTypes["Permissions"], "...on Permissions">
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["UserGroupModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserGroupModel']?: Omit<ValueTypes["UserGroupModel"], "...on UserGroupModel">
}>;
	["Users"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
	passwordResetToken?:boolean | `@${string}`,
	passwordResetExpiryDate?:boolean | `@${string}`,
	activateAccountToken?:boolean | `@${string}`,
	activateAccountExpiryDate?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	verifyEmailToken?:boolean | `@${string}`,
	verifyEmailExpiryDate?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	refreshToken?:boolean | `@${string}`,
	role?:ValueTypes["Role"],
	roleId?:boolean | `@${string}`,
	groups?:ValueTypes["UserGroupModel"],
	progress?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Users']?: Omit<ValueTypes["Users"], "...on Users">
}>;
	["AccountStatus"]:AccountStatus;
	["UserProgress"]:UserProgress;
	["UserPagination"]: AliasType<{
	users?:ValueTypes["Users"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserPagination']?: Omit<ValueTypes["UserPagination"], "...on UserPagination">
}>;
	["ImportUserError"]: AliasType<{
	line?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ImportUserError']?: Omit<ValueTypes["ImportUserError"], "...on ImportUserError">
}>;
	["ImportUsersReport"]: AliasType<{
	createdCount?:boolean | `@${string}`,
	errorCount?:boolean | `@${string}`,
	errors?:ValueTypes["ImportUserError"],
		__typename?: boolean | `@${string}`,
	['...on ImportUsersReport']?: Omit<ValueTypes["ImportUsersReport"], "...on ImportUsersReport">
}>;
	["Role"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	permissions?:ValueTypes["Permissions"],
	users?:ValueTypes["Users"],
		__typename?: boolean | `@${string}`,
	['...on Role']?: Omit<ValueTypes["Role"], "...on Role">
}>;
	["LearnerCountersModel"]: AliasType<{
	orgId?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	orgSlug?:boolean | `@${string}`,
	month?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	registeredLearners?:boolean | `@${string}`,
	leavingWithinThreeMonths?:boolean | `@${string}`,
	subscribedTier?:boolean | `@${string}`,
	effectiveTier?:boolean | `@${string}`,
	billedTier?:boolean | `@${string}`,
	placesRemaining?:boolean | `@${string}`,
	nextTier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	estimatedRevenueCents?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LearnerCountersModel']?: Omit<ValueTypes["LearnerCountersModel"], "...on LearnerCountersModel">
}>;
	["BillingTier"]:BillingTier;
	["BillingPaymentTerm"]:BillingPaymentTerm;
	["BillingAccountModel"]: AliasType<{
	id?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	tierChangedAt?:boolean | `@${string}`,
	companyName?:boolean | `@${string}`,
	addressLine1?:boolean | `@${string}`,
	addressLine2?:boolean | `@${string}`,
	postalCode?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
	vatNumber?:boolean | `@${string}`,
	billingEmail?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on BillingAccountModel']?: Omit<ValueTypes["BillingAccountModel"], "...on BillingAccountModel">
}>;
	["BillingEstimateModel"]: AliasType<{
	month?:boolean | `@${string}`,
	subscribedTier?:boolean | `@${string}`,
	effectiveTier?:boolean | `@${string}`,
	billedTier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	registeredLearners?:boolean | `@${string}`,
	placesRemaining?:boolean | `@${string}`,
	nextTier?:boolean | `@${string}`,
	leavingWithinThreeMonths?:boolean | `@${string}`,
	monthlyPriceCents?:boolean | `@${string}`,
	monthlyAmountCents?:boolean | `@${string}`,
	upfrontYearlyAmountCents?:boolean | `@${string}`,
	isCustom?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on BillingEstimateModel']?: Omit<ValueTypes["BillingEstimateModel"], "...on BillingEstimateModel">
}>;
	["PlanCapabilitiesModel"]: AliasType<{
	tier?:boolean | `@${string}`,
	canCustomizeBranding?:boolean | `@${string}`,
	canUseSso?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PlanCapabilitiesModel']?: Omit<ValueTypes["PlanCapabilitiesModel"], "...on PlanCapabilitiesModel">
}>;
	["BillingHistoryEntryModel"]: AliasType<{
	month?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on BillingHistoryEntryModel']?: Omit<ValueTypes["BillingHistoryEntryModel"], "...on BillingHistoryEntryModel">
}>;
	["AppConfigModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	appName?:boolean | `@${string}`,
	logo?:boolean | `@${string}`,
	favicon?:boolean | `@${string}`,
	primaryColor?:boolean | `@${string}`,
	accentColor?:boolean | `@${string}`,
	headingFont?:boolean | `@${string}`,
	bodyFont?:boolean | `@${string}`,
	footerText?:boolean | `@${string}`,
	defaultLocale?:boolean | `@${string}`,
	timezone?:boolean | `@${string}`,
	brandingLocked?:boolean | `@${string}`,
	signupCtaVisible?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AppConfigModel']?: Omit<ValueTypes["AppConfigModel"], "...on AppConfigModel">
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UniqueAuth']?: Omit<ValueTypes["UniqueAuth"], "...on UniqueAuth">
}>;
	["UserInfo"]: AliasType<{
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	roles?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	orgId?:boolean | `@${string}`,
	impersonatorId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserInfo']?: Omit<ValueTypes["UserInfo"], "...on UserInfo">
}>;
	["RoleEnum"]:RoleEnum;
	["CertificateTemplateModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	signature?:boolean | `@${string}`,
	showScore?:boolean | `@${string}`,
	showDate?:boolean | `@${string}`,
	showTotalTime?:boolean | `@${string}`,
	logo?:boolean | `@${string}`,
	orientation?:boolean | `@${string}`,
	hasSkeleton?:boolean | `@${string}`,
	marginTop?:boolean | `@${string}`,
	marginBottom?:boolean | `@${string}`,
	marginLeft?:boolean | `@${string}`,
	marginRight?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CertificateTemplateModel']?: Omit<ValueTypes["CertificateTemplateModel"], "...on CertificateTemplateModel">
}>;
	["CertificateOrientation"]:CertificateOrientation;
	["DownloadFile"]: AliasType<{
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DownloadFile']?: Omit<ValueTypes["DownloadFile"], "...on DownloadFile">
}>;
	["MyFiles"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	eTag?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	ownerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MyFiles']?: Omit<ValueTypes["MyFiles"], "...on MyFiles">
}>;
	["UploadPreSignedUrl"]: AliasType<{
	url?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UploadPreSignedUrl']?: Omit<ValueTypes["UploadPreSignedUrl"], "...on UploadPreSignedUrl">
}>;
	["GroupMemberModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on GroupMemberModel']?: Omit<ValueTypes["GroupMemberModel"], "...on GroupMemberModel">
}>;
	["GroupModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	memberCount?:boolean | `@${string}`,
	members?:ValueTypes["GroupMemberModel"],
		__typename?: boolean | `@${string}`,
	['...on GroupModel']?: Omit<ValueTypes["GroupModel"], "...on GroupModel">
}>;
	["HomeCompletionModel"]: AliasType<{
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
	moduleId?:boolean | `@${string}`,
	moduleTitle?:boolean | `@${string}`,
	learners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on HomeCompletionModel']?: Omit<ValueTypes["HomeCompletionModel"], "...on HomeCompletionModel">
}>;
	["HomeSessionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	endDate?:boolean | `@${string}`,
	enrolledLearners?:boolean | `@${string}`,
	pendingLearners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on HomeSessionModel']?: Omit<ValueTypes["HomeSessionModel"], "...on HomeSessionModel">
}>;
	["BackOfficeHomeModel"]: AliasType<{
	firstName?:boolean | `@${string}`,
	timezone?:boolean | `@${string}`,
	completedToday?:ValueTypes["HomeCompletionModel"],
	startingSoon?:ValueTypes["HomeSessionModel"],
	endingSoon?:ValueTypes["HomeSessionModel"],
	overdue?:ValueTypes["HomeSessionModel"],
	overdueLearners?:boolean | `@${string}`,
	overdueSessions?:boolean | `@${string}`,
	neverStartedLearners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on BackOfficeHomeModel']?: Omit<ValueTypes["BackOfficeHomeModel"], "...on BackOfficeHomeModel">
}>;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Mail']?: Omit<ValueTypes["Mail"], "...on Mail">
}>;
	["OrganizationModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	userCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on OrganizationModel']?: Omit<ValueTypes["OrganizationModel"], "...on OrganizationModel">
}>;
	["OrganizationStatus"]:OrganizationStatus;
	["OrgMemberModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on OrgMemberModel']?: Omit<ValueTypes["OrgMemberModel"], "...on OrgMemberModel">
}>;
	["ReminderSettingsModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	firstDelayDays?:boolean | `@${string}`,
	frequencyDays?:boolean | `@${string}`,
	maxReminders?:boolean | `@${string}`,
	sendHour?:boolean | `@${string}`,
	subject?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ReminderSettingsModel']?: Omit<ValueTypes["ReminderSettingsModel"], "...on ReminderSettingsModel">
}>;
	["ReminderTestResultModel"]: AliasType<{
	sent?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ReminderTestResultModel']?: Omit<ValueTypes["ReminderTestResultModel"], "...on ReminderTestResultModel">
}>;
	["StorageUsageModel"]: AliasType<{
	orgId?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	orgSlug?:boolean | `@${string}`,
	usedBytes?:boolean | `@${string}`,
	quotaBytes?:boolean | `@${string}`,
	remainingBytes?:boolean | `@${string}`,
	plan?:boolean | `@${string}`,
	moduleCount?:boolean | `@${string}`,
	overQuota?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on StorageUsageModel']?: Omit<ValueTypes["StorageUsageModel"], "...on StorageUsageModel">
}>;
	["ScormModuleModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	scormVersion?:boolean | `@${string}`,
	launchUrl?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	sizeBytes?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormModuleModel']?: Omit<ValueTypes["ScormModuleModel"], "...on ScormModuleModel">
}>;
	["ScormModuleStatus"]:ScormModuleStatus;
	["ScormTrackingModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	sessionId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingModel']?: Omit<ValueTypes["ScormTrackingModel"], "...on ScormTrackingModel">
}>;
	["ScormCompletionStatus"]:ScormCompletionStatus;
	["ScormSuccessStatus"]:ScormSuccessStatus;
	["ScormTrackingWithUser"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	userEmail?:boolean | `@${string}`,
	userFirstName?:boolean | `@${string}`,
	userLastName?:boolean | `@${string}`,
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingWithUser']?: Omit<ValueTypes["ScormTrackingWithUser"], "...on ScormTrackingWithUser">
}>;
	["ScormTrackingStats"]: AliasType<{
	total?:boolean | `@${string}`,
	completed?:boolean | `@${string}`,
	inProgress?:boolean | `@${string}`,
	notStarted?:boolean | `@${string}`,
	completionUnknown?:boolean | `@${string}`,
	neverOpened?:boolean | `@${string}`,
	notYetUnlocked?:boolean | `@${string}`,
	passed?:boolean | `@${string}`,
	failed?:boolean | `@${string}`,
	averageScorePercent?:boolean | `@${string}`,
	scoredCount?:boolean | `@${string}`,
	averageTimeSeconds?:boolean | `@${string}`,
	timedCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingStats']?: Omit<ValueTypes["ScormTrackingStats"], "...on ScormTrackingStats">
}>;
	["ScormTrackingPagination"]: AliasType<{
	trackings?:ValueTypes["ScormTrackingWithUser"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingPagination']?: Omit<ValueTypes["ScormTrackingPagination"], "...on ScormTrackingPagination">
}>;
	["SessionUserModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SessionUserModel']?: Omit<ValueTypes["SessionUserModel"], "...on SessionUserModel">
}>;
	["SessionModuleModel"]: AliasType<{
	id?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	unlockAt?:boolean | `@${string}`,
	module?:ValueTypes["ScormModuleModel"],
	unlocked?:boolean | `@${string}`,
	lockReason?:boolean | `@${string}`,
	myTracking?:ValueTypes["ScormTrackingModel"],
		__typename?: boolean | `@${string}`,
	['...on SessionModuleModel']?: Omit<ValueTypes["SessionModuleModel"], "...on SessionModuleModel">
}>;
	/** Pourquoi un module est fermé — une date à attendre, ou un module à finir. */
["ModuleLockReason"]:ModuleLockReason;
	["SessionProgressModel"]: AliasType<{
	totalModules?:boolean | `@${string}`,
	completedModules?:boolean | `@${string}`,
	completed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SessionProgressModel']?: Omit<ValueTypes["SessionProgressModel"], "...on SessionProgressModel">
}>;
	["SessionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	endDate?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	progressionMode?:boolean | `@${string}`,
	module?:ValueTypes["ScormModuleModel"],
	modules?:ValueTypes["SessionModuleModel"],
	enrolledUsers?:ValueTypes["SessionUserModel"],
	myTracking?:ValueTypes["ScormTrackingModel"],
	progress?:ValueTypes["SessionProgressModel"],
		__typename?: boolean | `@${string}`,
	['...on SessionModel']?: Omit<ValueTypes["SessionModel"], "...on SessionModel">
}>;
	["SessionStatus"]:SessionStatus;
	/** Règle d'enchaînement du parcours. Le déblocage par date n'est pas une valeur ici : c'est un second verrou, porté par SessionModule.unlockAt. */
["SessionProgressionMode"]:SessionProgressionMode;
	["RequestTrialResult"]: AliasType<{
	accepted?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on RequestTrialResult']?: Omit<ValueTypes["RequestTrialResult"], "...on RequestTrialResult">
}>;
	["ConfirmTrialResult"]: AliasType<{
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
	rejectionReason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ConfirmTrialResult']?: Omit<ValueTypes["ConfirmTrialResult"], "...on ConfirmTrialResult">
}>;
	["TrialReviewStatus"]:TrialReviewStatus;
	["TrialRequestModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	jobTitle?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	emailConfirmedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on TrialRequestModel']?: Omit<ValueTypes["TrialRequestModel"], "...on TrialRequestModel">
}>;
	["ApproveTrialResult"]: AliasType<{
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ApproveTrialResult']?: Omit<ValueTypes["ApproveTrialResult"], "...on ApproveTrialResult">
}>;
	["SsoOrgSettingsModel"]: AliasType<{
	enabled?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SsoOrgSettingsModel']?: Omit<ValueTypes["SsoOrgSettingsModel"], "...on SsoOrgSettingsModel">
}>;
	["SsoPresetModel"]: AliasType<{
	kind?:boolean | `@${string}`,
	protocol?:boolean | `@${string}`,
	defaultLabel?:boolean | `@${string}`,
	defaultIssuer?:boolean | `@${string}`,
	issuerHint?:boolean | `@${string}`,
	sharedIssuer?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SsoPresetModel']?: Omit<ValueTypes["SsoPresetModel"], "...on SsoPresetModel">
}>;
	/** Fournisseur d'identité pré-listé (#40). */
["SsoProviderKind"]:SsoProviderKind;
	["SsoProviderModel"]: AliasType<{
	id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	protocol?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	issuer?:boolean | `@${string}`,
	clientId?:boolean | `@${string}`,
	hasClientSecret?:boolean | `@${string}`,
	entryPoint?:boolean | `@${string}`,
	idpIssuer?:boolean | `@${string}`,
	idpCert?:boolean | `@${string}`,
	allowedDomains?:boolean | `@${string}`,
	requiresAllowedDomains?:boolean | `@${string}`,
	callbackUrl?:boolean | `@${string}`,
	metadataUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SsoProviderModel']?: Omit<ValueTypes["SsoProviderModel"], "...on SsoProviderModel">
}>;
	["PublicSsoProviderModel"]: AliasType<{
	id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	loginUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PublicSsoProviderModel']?: Omit<ValueTypes["PublicSsoProviderModel"], "...on PublicSsoProviderModel">
}>;
	["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Health']?: Omit<ValueTypes["Health"], "...on Health">
}>;
	["StatsNotice"]: AliasType<{
	status?:boolean | `@${string}`,
	acknowledgedAt?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
	currentVersion?:boolean | `@${string}`,
	needsAcknowledgement?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on StatsNotice']?: Omit<ValueTypes["StatsNotice"], "...on StatsNotice">
}>;
	["ConsentStatus"]:ConsentStatus;
	["Query"]: AliasType<{
	getHealthGql?:ValueTypes["Health"],
getRole?: [{	id: string | Variable<any, string>},ValueTypes["Role"]],
	getRoles?:ValueTypes["Role"],
getPermission?: [{	id: string | Variable<any, string>},ValueTypes["Permissions"]],
	getPermissions?:ValueTypes["Permissions"],
getMail?: [{	id: string | Variable<any, string>},ValueTypes["Mail"]],
	getMails?:ValueTypes["Mail"],
	appConfig?:ValueTypes["AppConfigModel"],
learnerCounters?: [{	month?: string | undefined | null | Variable<any, string>},ValueTypes["LearnerCountersModel"]],
learnerCountersByOrganization?: [{	month?: string | undefined | null | Variable<any, string>},ValueTypes["LearnerCountersModel"]],
	billingAccount?:ValueTypes["BillingAccountModel"],
	planCapabilities?:ValueTypes["PlanCapabilitiesModel"],
billingEstimate?: [{	month?: string | undefined | null | Variable<any, string>},ValueTypes["BillingEstimateModel"]],
billingHistory?: [{	months?: number | undefined | null | Variable<any, string>},ValueTypes["BillingHistoryEntryModel"]],
	me?:ValueTypes["UserInfo"],
getUser?: [{	id: string | Variable<any, string>},ValueTypes["Users"]],
	getUsers?:ValueTypes["Users"],
getExistingUserEmails?: [{	emails: Array<string> | Variable<any, string>},boolean | `@${string}`],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ValueTypes["FindManyUserWithFiltersInput"] | Variable<any, string>},ValueTypes["UserPagination"]],
	groups?:ValueTypes["GroupModel"],
group?: [{	id: ValueTypes["ID"] | Variable<any, string>},ValueTypes["GroupModel"]],
	ssoProviders?:ValueTypes["PublicSsoProviderModel"],
	ssoSettings?:ValueTypes["SsoOrgSettingsModel"],
	ssoPresets?:ValueTypes["SsoPresetModel"],
	ssoProviderConfigs?:ValueTypes["SsoProviderModel"],
	scormModules?:ValueTypes["ScormModuleModel"],
scormModule?: [{	id: ValueTypes["ID"] | Variable<any, string>},ValueTypes["ScormModuleModel"]],
	storageUsage?:ValueTypes["StorageUsageModel"],
	storageUsageByOrganization?:ValueTypes["StorageUsageModel"],
getMyScormTracking?: [{	sessionId: ValueTypes["ID"] | Variable<any, string>,	moduleId?: ValueTypes["ID"] | undefined | null | Variable<any, string>},ValueTypes["ScormTrackingModel"]],
getScormTrackings?: [{	input: ValueTypes["FindManyScormTrackingWithFiltersInput"] | Variable<any, string>},ValueTypes["ScormTrackingPagination"]],
getScormTrackingStats?: [{	input: ValueTypes["ScormTrackingStatsInput"] | Variable<any, string>},ValueTypes["ScormTrackingStats"]],
	sessions?:ValueTypes["SessionModel"],
session?: [{	id: ValueTypes["ID"] | Variable<any, string>},ValueTypes["SessionModel"]],
userSessions?: [{	userId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["SessionModel"]],
	mySessions?:ValueTypes["SessionModel"],
	pendingTrialRequests?:ValueTypes["TrialRequestModel"],
	backOfficeHome?:ValueTypes["BackOfficeHomeModel"],
	certificateTemplate?:ValueTypes["CertificateTemplateModel"],
downloadFile?: [{	eTag: string | Variable<any, string>},ValueTypes["DownloadFile"]],
	getAllMyFiles?:ValueTypes["MyFiles"],
publishBasicSubscription?: [{	from: string | Variable<any, string>,	to: string | Variable<any, string>},boolean | `@${string}`],
	myStatsNotice?:ValueTypes["StatsNotice"],
	organizations?:ValueTypes["OrganizationModel"],
organizationMembers?: [{	orgId: ValueTypes["ID"] | Variable<any, string>},ValueTypes["OrgMemberModel"]],
	reminderSettings?:ValueTypes["ReminderSettingsModel"],
		__typename?: boolean | `@${string}`,
	['...on Query']?: Omit<ValueTypes["Query"], "...on Query">
}>;
	["FindManyUserWithFiltersInput"]: {
	skip: number | Variable<any, string>,
	take: number | Variable<any, string>,
	searchInput: string | Variable<any, string>,
	orderBy?: ValueTypes["UserOrderByInput"] | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["UserFilterByInput"] | undefined | null | Variable<any, string>
};
	["UserOrderByInput"]: {
	email?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	firstName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastConnectionAt?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	role?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<string> | undefined | null | Variable<any, string>,
	group?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>,
	progress?: ValueTypes["UserProgress"] | undefined | null | Variable<any, string>
};
	["FindManyScormTrackingWithFiltersInput"]: {
	skip: number | Variable<any, string>,
	take: number | Variable<any, string>,
	searchInput?: string | undefined | null | Variable<any, string>,
	orderBy?: ValueTypes["ScormTrackingOrderByInput"] | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["ScormTrackingFilterByInput"] | undefined | null | Variable<any, string>
};
	["ScormTrackingOrderByInput"]: {
	userEmail?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	userFirstName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	userLastName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	completionStatus?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	successStatus?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	scoreRaw?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>
};
	["ScormTrackingFilterByInput"]: {
	completionStatus?: ValueTypes["ScormCompletionStatus"] | undefined | null | Variable<any, string>,
	successStatus?: ValueTypes["ScormSuccessStatus"] | undefined | null | Variable<any, string>,
	sessionId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	groupId?: ValueTypes["ID"] | undefined | null | Variable<any, string>
};
	["ScormTrackingStatsInput"]: {
	searchInput?: string | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["ScormStatsScopeInput"] | undefined | null | Variable<any, string>
};
	["ScormStatsScopeInput"]: {
	sessionId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	groupId?: ValueTypes["ID"] | undefined | null | Variable<any, string>
};
	["Mutation"]: AliasType<{
updateAppConfig?: [{	input: ValueTypes["UpdateAppConfigInput"] | Variable<any, string>},ValueTypes["AppConfigModel"]],
updateBillingProfile?: [{	input: ValueTypes["UpdateBillingProfileInput"] | Variable<any, string>},ValueTypes["BillingAccountModel"]],
changeBillingPlan?: [{	input: ValueTypes["ChangeBillingPlanInput"] | Variable<any, string>},ValueTypes["BillingAccountModel"]],
login?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>},ValueTypes["AuthType"]],
requestMagicLink?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
loginWithMagicLink?: [{	token: string | Variable<any, string>},ValueTypes["AuthType"]],
askForResetPassword?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
reSendEmailValidation?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
resetPassword?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
verifyEmail?: [{	email: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
finishRegister?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
	refresh?:ValueTypes["AuthType"],
	logout?:boolean | `@${string}`,
uniqueAuthFromSso?: [{	token: string | Variable<any, string>},ValueTypes["UniqueAuth"]],
impersonateUser?: [{	userId: string | Variable<any, string>},ValueTypes["AuthType"]],
	stopImpersonate?:ValueTypes["AuthType"],
createUser?: [{	createUserInput: ValueTypes["CreateUserInput"] | Variable<any, string>},ValueTypes["Users"]],
importUsers?: [{	users: Array<ValueTypes["ImportUserInput"]> | Variable<any, string>},ValueTypes["ImportUsersReport"]],
updateUser?: [{	updateUserInput: ValueTypes["UpdateUserInput"] | Variable<any, string>},ValueTypes["Users"]],
deleteUser?: [{	id: string | Variable<any, string>},boolean | `@${string}`],
createGroup?: [{	input: ValueTypes["CreateGroupInput"] | Variable<any, string>},ValueTypes["GroupModel"]],
updateGroup?: [{	id: ValueTypes["ID"] | Variable<any, string>,	input: ValueTypes["UpdateGroupInput"] | Variable<any, string>},ValueTypes["GroupModel"]],
deleteGroup?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
addUsersToGroup?: [{	groupId: ValueTypes["ID"] | Variable<any, string>,	userIds: Array<ValueTypes["ID"]> | Variable<any, string>},boolean | `@${string}`],
removeUsersFromGroup?: [{	groupId: ValueTypes["ID"] | Variable<any, string>,	userIds: Array<ValueTypes["ID"]> | Variable<any, string>},boolean | `@${string}`],
setSsoEnabled?: [{	enabled: boolean | Variable<any, string>},ValueTypes["SsoOrgSettingsModel"]],
upsertSsoProvider?: [{	input: ValueTypes["UpsertSsoProviderInput"] | Variable<any, string>},ValueTypes["SsoProviderModel"]],
deleteSsoProvider?: [{	kind: ValueTypes["SsoProviderKind"] | Variable<any, string>},boolean | `@${string}`],
deleteScormModule?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
upsertScormTracking?: [{	input: ValueTypes["UpsertScormTrackingInput"] | Variable<any, string>},ValueTypes["ScormTrackingModel"]],
createSession?: [{	input: ValueTypes["CreateSessionInput"] | Variable<any, string>},ValueTypes["SessionModel"]],
updateSession?: [{	id: ValueTypes["ID"] | Variable<any, string>,	input: ValueTypes["UpdateSessionInput"] | Variable<any, string>},ValueTypes["SessionModel"]],
deleteSession?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
requestTrialOrganization?: [{	input: ValueTypes["RequestTrialInput"] | Variable<any, string>},ValueTypes["RequestTrialResult"]],
confirmTrialOrganization?: [{	token: string | Variable<any, string>},ValueTypes["ConfirmTrialResult"]],
approveTrialRequest?: [{	id: string | Variable<any, string>},ValueTypes["ApproveTrialResult"]],
rejectTrialRequest?: [{	id: string | Variable<any, string>,	reason?: string | undefined | null | Variable<any, string>},boolean | `@${string}`],
updateCertificateTemplate?: [{	input: ValueTypes["UpdateCertificateTemplateInput"] | Variable<any, string>},ValueTypes["CertificateTemplateModel"]],
deleteFile?: [{	fileId: string | Variable<any, string>},boolean | `@${string}`],
uploadPreSignedUrl?: [{	mimeType: string | Variable<any, string>,	fileName: string | Variable<any, string>},ValueTypes["UploadPreSignedUrl"]],
confirmUpload?: [{	id: string | Variable<any, string>,	status: boolean | Variable<any, string>},boolean | `@${string}`],
	acknowledgeStatsNotice?:ValueTypes["StatsNotice"],
createOrganization?: [{	input: ValueTypes["CreateOrganizationInput"] | Variable<any, string>},ValueTypes["OrganizationModel"]],
setOrganizationStatus?: [{	id: string | Variable<any, string>,	status: ValueTypes["OrganizationStatus"] | Variable<any, string>},ValueTypes["OrganizationModel"]],
updateOrganization?: [{	input: ValueTypes["UpdateOrganizationInput"] | Variable<any, string>},ValueTypes["OrganizationModel"]],
deleteOrganization?: [{	id: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
inviteOrgMember?: [{	input: ValueTypes["InviteOrgMemberInput"] | Variable<any, string>},ValueTypes["OrgMemberModel"]],
removeOrgMember?: [{	orgId: ValueTypes["ID"] | Variable<any, string>,	userId: ValueTypes["ID"] | Variable<any, string>},boolean | `@${string}`],
updateReminderSettings?: [{	input: ValueTypes["UpdateReminderSettingsInput"] | Variable<any, string>},ValueTypes["ReminderSettingsModel"]],
sendReminderTest?: [{	input?: ValueTypes["UpdateReminderSettingsInput"] | undefined | null | Variable<any, string>},ValueTypes["ReminderTestResultModel"]],
		__typename?: boolean | `@${string}`,
	['...on Mutation']?: Omit<ValueTypes["Mutation"], "...on Mutation">
}>;
	["UpdateAppConfigInput"]: {
	appName?: string | undefined | null | Variable<any, string>,
	logo?: string | undefined | null | Variable<any, string>,
	favicon?: string | undefined | null | Variable<any, string>,
	primaryColor?: string | undefined | null | Variable<any, string>,
	accentColor?: string | undefined | null | Variable<any, string>,
	headingFont?: string | undefined | null | Variable<any, string>,
	bodyFont?: string | undefined | null | Variable<any, string>,
	footerText?: string | undefined | null | Variable<any, string>,
	defaultLocale?: string | undefined | null | Variable<any, string>
};
	["UpdateBillingProfileInput"]: {
	companyName?: string | undefined | null | Variable<any, string>,
	addressLine1?: string | undefined | null | Variable<any, string>,
	addressLine2?: string | undefined | null | Variable<any, string>,
	postalCode?: string | undefined | null | Variable<any, string>,
	city?: string | undefined | null | Variable<any, string>,
	country?: string | undefined | null | Variable<any, string>,
	vatNumber?: string | undefined | null | Variable<any, string>,
	billingEmail?: string | undefined | null | Variable<any, string>
};
	["ChangeBillingPlanInput"]: {
	tier: ValueTypes["BillingTier"] | Variable<any, string>,
	paymentTerm?: ValueTypes["BillingPaymentTerm"] | undefined | null | Variable<any, string>
};
	["AuthType"]: AliasType<{		["...on UserInfo"]?: ValueTypes["UserInfo"],
		["...on CustomError"]?: ValueTypes["CustomError"]
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CustomError']?: Omit<ValueTypes["CustomError"], "...on CustomError">
}>;
	["EError"]:EError;
	["CreateUserInput"]: {
	email: string | Variable<any, string>,
	password?: string | undefined | null | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	roleId: string | Variable<any, string>,
	group?: string | undefined | null | Variable<any, string>
};
	["ImportUserInput"]: {
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	group?: string | undefined | null | Variable<any, string>
};
	["UpdateUserInput"]: {
	email?: string | undefined | null | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	roleId?: string | undefined | null | Variable<any, string>,
	id: string | Variable<any, string>
};
	["CreateGroupInput"]: {
	name: string | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	userIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>
};
	["UpdateGroupInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	description?: string | undefined | null | Variable<any, string>,
	userIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>
};
	["UpsertSsoProviderInput"]: {
	kind: ValueTypes["SsoProviderKind"] | Variable<any, string>,
	label?: string | undefined | null | Variable<any, string>,
	enabled?: boolean | undefined | null | Variable<any, string>,
	issuer?: string | undefined | null | Variable<any, string>,
	clientId?: string | undefined | null | Variable<any, string>,
	clientSecret?: string | undefined | null | Variable<any, string>,
	entryPoint?: string | undefined | null | Variable<any, string>,
	idpIssuer?: string | undefined | null | Variable<any, string>,
	idpCert?: string | undefined | null | Variable<any, string>,
	allowedDomains?: Array<string> | undefined | null | Variable<any, string>
};
	["UpsertScormTrackingInput"]: {
	sessionId: ValueTypes["ID"] | Variable<any, string>,
	moduleId?: ValueTypes["ID"] | undefined | null | Variable<any, string>,
	completionStatus?: ValueTypes["ScormCompletionStatus"] | undefined | null | Variable<any, string>,
	successStatus?: ValueTypes["ScormSuccessStatus"] | undefined | null | Variable<any, string>,
	scoreRaw?: number | undefined | null | Variable<any, string>,
	scoreMin?: number | undefined | null | Variable<any, string>,
	scoreMax?: number | undefined | null | Variable<any, string>,
	scoreScaled?: number | undefined | null | Variable<any, string>,
	totalTime?: string | undefined | null | Variable<any, string>,
	sessionTime?: string | undefined | null | Variable<any, string>,
	suspendData?: string | undefined | null | Variable<any, string>,
	location?: string | undefined | null | Variable<any, string>
};
	["CreateSessionInput"]: {
	name: string | Variable<any, string>,
	modules: Array<ValueTypes["SessionModuleInput"]> | Variable<any, string>,
	progressionMode?: ValueTypes["SessionProgressionMode"] | undefined | null | Variable<any, string>,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null | Variable<any, string>,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null | Variable<any, string>,
	userIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>
};
	["SessionModuleInput"]: {
	moduleId: ValueTypes["ID"] | Variable<any, string>,
	/** Jour civil au format AAAA-MM-JJ */
	unlockAt?: string | undefined | null | Variable<any, string>
};
	["UpdateSessionInput"]: {
	name?: string | undefined | null | Variable<any, string>,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null | Variable<any, string>,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null | Variable<any, string>,
	status?: ValueTypes["SessionStatus"] | undefined | null | Variable<any, string>,
	progressionMode?: ValueTypes["SessionProgressionMode"] | undefined | null | Variable<any, string>,
	modules?: Array<ValueTypes["SessionModuleInput"]> | undefined | null | Variable<any, string>,
	userIds?: Array<ValueTypes["ID"]> | undefined | null | Variable<any, string>
};
	["RequestTrialInput"]: {
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	orgName: string | Variable<any, string>,
	phone?: string | undefined | null | Variable<any, string>,
	jobTitle?: string | undefined | null | Variable<any, string>
};
	["UpdateCertificateTemplateInput"]: {
	title?: string | undefined | null | Variable<any, string>,
	body?: string | undefined | null | Variable<any, string>,
	signature?: string | undefined | null | Variable<any, string>,
	showScore?: boolean | undefined | null | Variable<any, string>,
	showDate?: boolean | undefined | null | Variable<any, string>,
	showTotalTime?: boolean | undefined | null | Variable<any, string>,
	logo?: string | undefined | null | Variable<any, string>,
	orientation?: ValueTypes["CertificateOrientation"] | undefined | null | Variable<any, string>,
	skeletonPdf?: string | undefined | null | Variable<any, string>,
	marginTop?: number | undefined | null | Variable<any, string>,
	marginBottom?: number | undefined | null | Variable<any, string>,
	marginLeft?: number | undefined | null | Variable<any, string>,
	marginRight?: number | undefined | null | Variable<any, string>
};
	["CreateOrganizationInput"]: {
	name: string | Variable<any, string>,
	slug: string | Variable<any, string>,
	adminEmail: string | Variable<any, string>,
	adminFirstName: string | Variable<any, string>,
	adminLastName: string | Variable<any, string>
};
	["UpdateOrganizationInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	slug?: string | undefined | null | Variable<any, string>,
	status?: ValueTypes["OrganizationStatus"] | undefined | null | Variable<any, string>
};
	["InviteOrgMemberInput"]: {
	orgId: ValueTypes["ID"] | Variable<any, string>,
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	role: ValueTypes["RoleEnum"] | Variable<any, string>
};
	["UpdateReminderSettingsInput"]: {
	enabled?: boolean | undefined | null | Variable<any, string>,
	firstDelayDays?: number | undefined | null | Variable<any, string>,
	frequencyDays?: number | undefined | null | Variable<any, string>,
	maxReminders?: number | undefined | null | Variable<any, string>,
	sendHour?: number | undefined | null | Variable<any, string>,
	subject?: string | undefined | null | Variable<any, string>,
	body?: string | undefined | null | Variable<any, string>
};
	["Subscription"]: AliasType<{
basicSubscription?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
		__typename?: boolean | `@${string}`,
	['...on Subscription']?: Omit<ValueTypes["Subscription"], "...on Subscription">
}>;
	["ID"]:unknown
  }

export type ResolverInputTypes = {
    ["Permissions"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:ResolverInputTypes["Role"],
		__typename?: boolean | `@${string}`
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["UserGroupModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Users"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
	passwordResetToken?:boolean | `@${string}`,
	passwordResetExpiryDate?:boolean | `@${string}`,
	activateAccountToken?:boolean | `@${string}`,
	activateAccountExpiryDate?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	verifyEmailToken?:boolean | `@${string}`,
	verifyEmailExpiryDate?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	refreshToken?:boolean | `@${string}`,
	role?:ResolverInputTypes["Role"],
	roleId?:boolean | `@${string}`,
	groups?:ResolverInputTypes["UserGroupModel"],
	progress?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AccountStatus"]:AccountStatus;
	["UserProgress"]:UserProgress;
	["UserPagination"]: AliasType<{
	users?:ResolverInputTypes["Users"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ImportUserError"]: AliasType<{
	line?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ImportUsersReport"]: AliasType<{
	createdCount?:boolean | `@${string}`,
	errorCount?:boolean | `@${string}`,
	errors?:ResolverInputTypes["ImportUserError"],
		__typename?: boolean | `@${string}`
}>;
	["Role"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	permissions?:ResolverInputTypes["Permissions"],
	users?:ResolverInputTypes["Users"],
		__typename?: boolean | `@${string}`
}>;
	["LearnerCountersModel"]: AliasType<{
	orgId?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	orgSlug?:boolean | `@${string}`,
	month?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	registeredLearners?:boolean | `@${string}`,
	leavingWithinThreeMonths?:boolean | `@${string}`,
	subscribedTier?:boolean | `@${string}`,
	effectiveTier?:boolean | `@${string}`,
	billedTier?:boolean | `@${string}`,
	placesRemaining?:boolean | `@${string}`,
	nextTier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	estimatedRevenueCents?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BillingTier"]:BillingTier;
	["BillingPaymentTerm"]:BillingPaymentTerm;
	["BillingAccountModel"]: AliasType<{
	id?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	tierChangedAt?:boolean | `@${string}`,
	companyName?:boolean | `@${string}`,
	addressLine1?:boolean | `@${string}`,
	addressLine2?:boolean | `@${string}`,
	postalCode?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	country?:boolean | `@${string}`,
	vatNumber?:boolean | `@${string}`,
	billingEmail?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BillingEstimateModel"]: AliasType<{
	month?:boolean | `@${string}`,
	subscribedTier?:boolean | `@${string}`,
	effectiveTier?:boolean | `@${string}`,
	billedTier?:boolean | `@${string}`,
	paymentTerm?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	registeredLearners?:boolean | `@${string}`,
	placesRemaining?:boolean | `@${string}`,
	nextTier?:boolean | `@${string}`,
	leavingWithinThreeMonths?:boolean | `@${string}`,
	monthlyPriceCents?:boolean | `@${string}`,
	monthlyAmountCents?:boolean | `@${string}`,
	upfrontYearlyAmountCents?:boolean | `@${string}`,
	isCustom?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PlanCapabilitiesModel"]: AliasType<{
	tier?:boolean | `@${string}`,
	canCustomizeBranding?:boolean | `@${string}`,
	canUseSso?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BillingHistoryEntryModel"]: AliasType<{
	month?:boolean | `@${string}`,
	monthlyActive?:boolean | `@${string}`,
	learnerCount?:boolean | `@${string}`,
	tier?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AppConfigModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	appName?:boolean | `@${string}`,
	logo?:boolean | `@${string}`,
	favicon?:boolean | `@${string}`,
	primaryColor?:boolean | `@${string}`,
	accentColor?:boolean | `@${string}`,
	headingFont?:boolean | `@${string}`,
	bodyFont?:boolean | `@${string}`,
	footerText?:boolean | `@${string}`,
	defaultLocale?:boolean | `@${string}`,
	timezone?:boolean | `@${string}`,
	brandingLocked?:boolean | `@${string}`,
	signupCtaVisible?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserInfo"]: AliasType<{
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	roles?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	orgId?:boolean | `@${string}`,
	impersonatorId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RoleEnum"]:RoleEnum;
	["CertificateTemplateModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	signature?:boolean | `@${string}`,
	showScore?:boolean | `@${string}`,
	showDate?:boolean | `@${string}`,
	showTotalTime?:boolean | `@${string}`,
	logo?:boolean | `@${string}`,
	orientation?:boolean | `@${string}`,
	hasSkeleton?:boolean | `@${string}`,
	marginTop?:boolean | `@${string}`,
	marginBottom?:boolean | `@${string}`,
	marginLeft?:boolean | `@${string}`,
	marginRight?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CertificateOrientation"]:CertificateOrientation;
	["DownloadFile"]: AliasType<{
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MyFiles"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	eTag?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	ownerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UploadPreSignedUrl"]: AliasType<{
	url?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GroupMemberModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GroupModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	memberCount?:boolean | `@${string}`,
	members?:ResolverInputTypes["GroupMemberModel"],
		__typename?: boolean | `@${string}`
}>;
	["HomeCompletionModel"]: AliasType<{
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
	moduleId?:boolean | `@${string}`,
	moduleTitle?:boolean | `@${string}`,
	learners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["HomeSessionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	endDate?:boolean | `@${string}`,
	enrolledLearners?:boolean | `@${string}`,
	pendingLearners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BackOfficeHomeModel"]: AliasType<{
	firstName?:boolean | `@${string}`,
	timezone?:boolean | `@${string}`,
	completedToday?:ResolverInputTypes["HomeCompletionModel"],
	startingSoon?:ResolverInputTypes["HomeSessionModel"],
	endingSoon?:ResolverInputTypes["HomeSessionModel"],
	overdue?:ResolverInputTypes["HomeSessionModel"],
	overdueLearners?:boolean | `@${string}`,
	overdueSessions?:boolean | `@${string}`,
	neverStartedLearners?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OrganizationModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	userCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OrganizationStatus"]:OrganizationStatus;
	["OrgMemberModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReminderSettingsModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	firstDelayDays?:boolean | `@${string}`,
	frequencyDays?:boolean | `@${string}`,
	maxReminders?:boolean | `@${string}`,
	sendHour?:boolean | `@${string}`,
	subject?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReminderTestResultModel"]: AliasType<{
	sent?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StorageUsageModel"]: AliasType<{
	orgId?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	orgSlug?:boolean | `@${string}`,
	usedBytes?:boolean | `@${string}`,
	quotaBytes?:boolean | `@${string}`,
	remainingBytes?:boolean | `@${string}`,
	plan?:boolean | `@${string}`,
	moduleCount?:boolean | `@${string}`,
	overQuota?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormModuleModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	scormVersion?:boolean | `@${string}`,
	launchUrl?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	sizeBytes?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormModuleStatus"]:ScormModuleStatus;
	["ScormTrackingModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	sessionId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormCompletionStatus"]:ScormCompletionStatus;
	["ScormSuccessStatus"]:ScormSuccessStatus;
	["ScormTrackingWithUser"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	userEmail?:boolean | `@${string}`,
	userFirstName?:boolean | `@${string}`,
	userLastName?:boolean | `@${string}`,
	sessionId?:boolean | `@${string}`,
	sessionName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormTrackingStats"]: AliasType<{
	total?:boolean | `@${string}`,
	completed?:boolean | `@${string}`,
	inProgress?:boolean | `@${string}`,
	notStarted?:boolean | `@${string}`,
	completionUnknown?:boolean | `@${string}`,
	neverOpened?:boolean | `@${string}`,
	notYetUnlocked?:boolean | `@${string}`,
	passed?:boolean | `@${string}`,
	failed?:boolean | `@${string}`,
	averageScorePercent?:boolean | `@${string}`,
	scoredCount?:boolean | `@${string}`,
	averageTimeSeconds?:boolean | `@${string}`,
	timedCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormTrackingPagination"]: AliasType<{
	trackings?:ResolverInputTypes["ScormTrackingWithUser"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionUserModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionModuleModel"]: AliasType<{
	id?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	unlockAt?:boolean | `@${string}`,
	module?:ResolverInputTypes["ScormModuleModel"],
	unlocked?:boolean | `@${string}`,
	lockReason?:boolean | `@${string}`,
	myTracking?:ResolverInputTypes["ScormTrackingModel"],
		__typename?: boolean | `@${string}`
}>;
	/** Pourquoi un module est fermé — une date à attendre, ou un module à finir. */
["ModuleLockReason"]:ModuleLockReason;
	["SessionProgressModel"]: AliasType<{
	totalModules?:boolean | `@${string}`,
	completedModules?:boolean | `@${string}`,
	completed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SessionModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	endDate?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	progressionMode?:boolean | `@${string}`,
	module?:ResolverInputTypes["ScormModuleModel"],
	modules?:ResolverInputTypes["SessionModuleModel"],
	enrolledUsers?:ResolverInputTypes["SessionUserModel"],
	myTracking?:ResolverInputTypes["ScormTrackingModel"],
	progress?:ResolverInputTypes["SessionProgressModel"],
		__typename?: boolean | `@${string}`
}>;
	["SessionStatus"]:SessionStatus;
	/** Règle d'enchaînement du parcours. Le déblocage par date n'est pas une valeur ici : c'est un second verrou, porté par SessionModule.unlockAt. */
["SessionProgressionMode"]:SessionProgressionMode;
	["RequestTrialResult"]: AliasType<{
	accepted?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ConfirmTrialResult"]: AliasType<{
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
	rejectionReason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TrialReviewStatus"]:TrialReviewStatus;
	["TrialRequestModel"]: AliasType<{
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	orgName?:boolean | `@${string}`,
	jobTitle?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	emailConfirmedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ApproveTrialResult"]: AliasType<{
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SsoOrgSettingsModel"]: AliasType<{
	enabled?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SsoPresetModel"]: AliasType<{
	kind?:boolean | `@${string}`,
	protocol?:boolean | `@${string}`,
	defaultLabel?:boolean | `@${string}`,
	defaultIssuer?:boolean | `@${string}`,
	issuerHint?:boolean | `@${string}`,
	sharedIssuer?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Fournisseur d'identité pré-listé (#40). */
["SsoProviderKind"]:SsoProviderKind;
	["SsoProviderModel"]: AliasType<{
	id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	protocol?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
	issuer?:boolean | `@${string}`,
	clientId?:boolean | `@${string}`,
	hasClientSecret?:boolean | `@${string}`,
	entryPoint?:boolean | `@${string}`,
	idpIssuer?:boolean | `@${string}`,
	idpCert?:boolean | `@${string}`,
	allowedDomains?:boolean | `@${string}`,
	requiresAllowedDomains?:boolean | `@${string}`,
	callbackUrl?:boolean | `@${string}`,
	metadataUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PublicSsoProviderModel"]: AliasType<{
	id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	loginUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StatsNotice"]: AliasType<{
	status?:boolean | `@${string}`,
	acknowledgedAt?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
	currentVersion?:boolean | `@${string}`,
	needsAcknowledgement?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ConsentStatus"]:ConsentStatus;
	["Query"]: AliasType<{
	getHealthGql?:ResolverInputTypes["Health"],
getRole?: [{	id: string},ResolverInputTypes["Role"]],
	getRoles?:ResolverInputTypes["Role"],
getPermission?: [{	id: string},ResolverInputTypes["Permissions"]],
	getPermissions?:ResolverInputTypes["Permissions"],
getMail?: [{	id: string},ResolverInputTypes["Mail"]],
	getMails?:ResolverInputTypes["Mail"],
	appConfig?:ResolverInputTypes["AppConfigModel"],
learnerCounters?: [{	month?: string | undefined | null},ResolverInputTypes["LearnerCountersModel"]],
learnerCountersByOrganization?: [{	month?: string | undefined | null},ResolverInputTypes["LearnerCountersModel"]],
	billingAccount?:ResolverInputTypes["BillingAccountModel"],
	planCapabilities?:ResolverInputTypes["PlanCapabilitiesModel"],
billingEstimate?: [{	month?: string | undefined | null},ResolverInputTypes["BillingEstimateModel"]],
billingHistory?: [{	months?: number | undefined | null},ResolverInputTypes["BillingHistoryEntryModel"]],
	me?:ResolverInputTypes["UserInfo"],
getUser?: [{	id: string},ResolverInputTypes["Users"]],
	getUsers?:ResolverInputTypes["Users"],
getExistingUserEmails?: [{	emails: Array<string>},boolean | `@${string}`],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ResolverInputTypes["FindManyUserWithFiltersInput"]},ResolverInputTypes["UserPagination"]],
	groups?:ResolverInputTypes["GroupModel"],
group?: [{	id: ResolverInputTypes["ID"]},ResolverInputTypes["GroupModel"]],
	ssoProviders?:ResolverInputTypes["PublicSsoProviderModel"],
	ssoSettings?:ResolverInputTypes["SsoOrgSettingsModel"],
	ssoPresets?:ResolverInputTypes["SsoPresetModel"],
	ssoProviderConfigs?:ResolverInputTypes["SsoProviderModel"],
	scormModules?:ResolverInputTypes["ScormModuleModel"],
scormModule?: [{	id: ResolverInputTypes["ID"]},ResolverInputTypes["ScormModuleModel"]],
	storageUsage?:ResolverInputTypes["StorageUsageModel"],
	storageUsageByOrganization?:ResolverInputTypes["StorageUsageModel"],
getMyScormTracking?: [{	sessionId: ResolverInputTypes["ID"],	moduleId?: ResolverInputTypes["ID"] | undefined | null},ResolverInputTypes["ScormTrackingModel"]],
getScormTrackings?: [{	input: ResolverInputTypes["FindManyScormTrackingWithFiltersInput"]},ResolverInputTypes["ScormTrackingPagination"]],
getScormTrackingStats?: [{	input: ResolverInputTypes["ScormTrackingStatsInput"]},ResolverInputTypes["ScormTrackingStats"]],
	sessions?:ResolverInputTypes["SessionModel"],
session?: [{	id: ResolverInputTypes["ID"]},ResolverInputTypes["SessionModel"]],
userSessions?: [{	userId: ResolverInputTypes["ID"]},ResolverInputTypes["SessionModel"]],
	mySessions?:ResolverInputTypes["SessionModel"],
	pendingTrialRequests?:ResolverInputTypes["TrialRequestModel"],
	backOfficeHome?:ResolverInputTypes["BackOfficeHomeModel"],
	certificateTemplate?:ResolverInputTypes["CertificateTemplateModel"],
downloadFile?: [{	eTag: string},ResolverInputTypes["DownloadFile"]],
	getAllMyFiles?:ResolverInputTypes["MyFiles"],
publishBasicSubscription?: [{	from: string,	to: string},boolean | `@${string}`],
	myStatsNotice?:ResolverInputTypes["StatsNotice"],
	organizations?:ResolverInputTypes["OrganizationModel"],
organizationMembers?: [{	orgId: ResolverInputTypes["ID"]},ResolverInputTypes["OrgMemberModel"]],
	reminderSettings?:ResolverInputTypes["ReminderSettingsModel"],
		__typename?: boolean | `@${string}`
}>;
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ResolverInputTypes["UserOrderByInput"] | undefined | null,
	filterBy?: ResolverInputTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
	email?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	firstName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	role?: ResolverInputTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<string> | undefined | null,
	group?: Array<ResolverInputTypes["ID"]> | undefined | null,
	progress?: ResolverInputTypes["UserProgress"] | undefined | null
};
	["FindManyScormTrackingWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput?: string | undefined | null,
	orderBy?: ResolverInputTypes["ScormTrackingOrderByInput"] | undefined | null,
	filterBy?: ResolverInputTypes["ScormTrackingFilterByInput"] | undefined | null
};
	["ScormTrackingOrderByInput"]: {
	userEmail?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	userFirstName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	userLastName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	completionStatus?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	successStatus?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	scoreRaw?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	completedAt?: ResolverInputTypes["OrderByEnum"] | undefined | null
};
	["ScormTrackingFilterByInput"]: {
	completionStatus?: ResolverInputTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ResolverInputTypes["ScormSuccessStatus"] | undefined | null,
	sessionId?: ResolverInputTypes["ID"] | undefined | null,
	groupId?: ResolverInputTypes["ID"] | undefined | null
};
	["ScormTrackingStatsInput"]: {
	searchInput?: string | undefined | null,
	filterBy?: ResolverInputTypes["ScormStatsScopeInput"] | undefined | null
};
	["ScormStatsScopeInput"]: {
	sessionId?: ResolverInputTypes["ID"] | undefined | null,
	groupId?: ResolverInputTypes["ID"] | undefined | null
};
	["Mutation"]: AliasType<{
updateAppConfig?: [{	input: ResolverInputTypes["UpdateAppConfigInput"]},ResolverInputTypes["AppConfigModel"]],
updateBillingProfile?: [{	input: ResolverInputTypes["UpdateBillingProfileInput"]},ResolverInputTypes["BillingAccountModel"]],
changeBillingPlan?: [{	input: ResolverInputTypes["ChangeBillingPlanInput"]},ResolverInputTypes["BillingAccountModel"]],
login?: [{	email: string,	password: string},ResolverInputTypes["AuthType"]],
requestMagicLink?: [{	email: string},boolean | `@${string}`],
loginWithMagicLink?: [{	token: string},ResolverInputTypes["AuthType"]],
askForResetPassword?: [{	email: string},boolean | `@${string}`],
reSendEmailValidation?: [{	email: string},boolean | `@${string}`],
resetPassword?: [{	email: string,	password: string,	token: string},boolean | `@${string}`],
verifyEmail?: [{	email: string,	token: string},boolean | `@${string}`],
finishRegister?: [{	email: string,	password: string,	firstName: string,	lastName: string,	token: string},boolean | `@${string}`],
	refresh?:ResolverInputTypes["AuthType"],
	logout?:boolean | `@${string}`,
uniqueAuthFromSso?: [{	token: string},ResolverInputTypes["UniqueAuth"]],
impersonateUser?: [{	userId: string},ResolverInputTypes["AuthType"]],
	stopImpersonate?:ResolverInputTypes["AuthType"],
createUser?: [{	createUserInput: ResolverInputTypes["CreateUserInput"]},ResolverInputTypes["Users"]],
importUsers?: [{	users: Array<ResolverInputTypes["ImportUserInput"]>},ResolverInputTypes["ImportUsersReport"]],
updateUser?: [{	updateUserInput: ResolverInputTypes["UpdateUserInput"]},ResolverInputTypes["Users"]],
deleteUser?: [{	id: string},boolean | `@${string}`],
createGroup?: [{	input: ResolverInputTypes["CreateGroupInput"]},ResolverInputTypes["GroupModel"]],
updateGroup?: [{	id: ResolverInputTypes["ID"],	input: ResolverInputTypes["UpdateGroupInput"]},ResolverInputTypes["GroupModel"]],
deleteGroup?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
addUsersToGroup?: [{	groupId: ResolverInputTypes["ID"],	userIds: Array<ResolverInputTypes["ID"]>},boolean | `@${string}`],
removeUsersFromGroup?: [{	groupId: ResolverInputTypes["ID"],	userIds: Array<ResolverInputTypes["ID"]>},boolean | `@${string}`],
setSsoEnabled?: [{	enabled: boolean},ResolverInputTypes["SsoOrgSettingsModel"]],
upsertSsoProvider?: [{	input: ResolverInputTypes["UpsertSsoProviderInput"]},ResolverInputTypes["SsoProviderModel"]],
deleteSsoProvider?: [{	kind: ResolverInputTypes["SsoProviderKind"]},boolean | `@${string}`],
deleteScormModule?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
upsertScormTracking?: [{	input: ResolverInputTypes["UpsertScormTrackingInput"]},ResolverInputTypes["ScormTrackingModel"]],
createSession?: [{	input: ResolverInputTypes["CreateSessionInput"]},ResolverInputTypes["SessionModel"]],
updateSession?: [{	id: ResolverInputTypes["ID"],	input: ResolverInputTypes["UpdateSessionInput"]},ResolverInputTypes["SessionModel"]],
deleteSession?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
requestTrialOrganization?: [{	input: ResolverInputTypes["RequestTrialInput"]},ResolverInputTypes["RequestTrialResult"]],
confirmTrialOrganization?: [{	token: string},ResolverInputTypes["ConfirmTrialResult"]],
approveTrialRequest?: [{	id: string},ResolverInputTypes["ApproveTrialResult"]],
rejectTrialRequest?: [{	id: string,	reason?: string | undefined | null},boolean | `@${string}`],
updateCertificateTemplate?: [{	input: ResolverInputTypes["UpdateCertificateTemplateInput"]},ResolverInputTypes["CertificateTemplateModel"]],
deleteFile?: [{	fileId: string},boolean | `@${string}`],
uploadPreSignedUrl?: [{	mimeType: string,	fileName: string},ResolverInputTypes["UploadPreSignedUrl"]],
confirmUpload?: [{	id: string,	status: boolean},boolean | `@${string}`],
	acknowledgeStatsNotice?:ResolverInputTypes["StatsNotice"],
createOrganization?: [{	input: ResolverInputTypes["CreateOrganizationInput"]},ResolverInputTypes["OrganizationModel"]],
setOrganizationStatus?: [{	id: string,	status: ResolverInputTypes["OrganizationStatus"]},ResolverInputTypes["OrganizationModel"]],
updateOrganization?: [{	input: ResolverInputTypes["UpdateOrganizationInput"]},ResolverInputTypes["OrganizationModel"]],
deleteOrganization?: [{	id: ResolverInputTypes["ID"]},boolean | `@${string}`],
inviteOrgMember?: [{	input: ResolverInputTypes["InviteOrgMemberInput"]},ResolverInputTypes["OrgMemberModel"]],
removeOrgMember?: [{	orgId: ResolverInputTypes["ID"],	userId: ResolverInputTypes["ID"]},boolean | `@${string}`],
updateReminderSettings?: [{	input: ResolverInputTypes["UpdateReminderSettingsInput"]},ResolverInputTypes["ReminderSettingsModel"]],
sendReminderTest?: [{	input?: ResolverInputTypes["UpdateReminderSettingsInput"] | undefined | null},ResolverInputTypes["ReminderTestResultModel"]],
		__typename?: boolean | `@${string}`
}>;
	["UpdateAppConfigInput"]: {
	appName?: string | undefined | null,
	logo?: string | undefined | null,
	favicon?: string | undefined | null,
	primaryColor?: string | undefined | null,
	accentColor?: string | undefined | null,
	headingFont?: string | undefined | null,
	bodyFont?: string | undefined | null,
	footerText?: string | undefined | null,
	defaultLocale?: string | undefined | null
};
	["UpdateBillingProfileInput"]: {
	companyName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	postalCode?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	vatNumber?: string | undefined | null,
	billingEmail?: string | undefined | null
};
	["ChangeBillingPlanInput"]: {
	tier: ResolverInputTypes["BillingTier"],
	paymentTerm?: ResolverInputTypes["BillingPaymentTerm"] | undefined | null
};
	["AuthType"]: AliasType<{
	UserInfo?:ResolverInputTypes["UserInfo"],
	CustomError?:ResolverInputTypes["CustomError"],
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EError"]:EError;
	["CreateUserInput"]: {
	email: string,
	password?: string | undefined | null,
	firstName: string,
	lastName: string,
	roleId: string,
	group?: string | undefined | null
};
	["ImportUserInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	group?: string | undefined | null
};
	["UpdateUserInput"]: {
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: string | undefined | null,
	id: string
};
	["CreateGroupInput"]: {
	name: string,
	description?: string | undefined | null,
	userIds?: Array<ResolverInputTypes["ID"]> | undefined | null
};
	["UpdateGroupInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	userIds?: Array<ResolverInputTypes["ID"]> | undefined | null
};
	["UpsertSsoProviderInput"]: {
	kind: ResolverInputTypes["SsoProviderKind"],
	label?: string | undefined | null,
	enabled?: boolean | undefined | null,
	issuer?: string | undefined | null,
	clientId?: string | undefined | null,
	clientSecret?: string | undefined | null,
	entryPoint?: string | undefined | null,
	idpIssuer?: string | undefined | null,
	idpCert?: string | undefined | null,
	allowedDomains?: Array<string> | undefined | null
};
	["UpsertScormTrackingInput"]: {
	sessionId: ResolverInputTypes["ID"],
	moduleId?: ResolverInputTypes["ID"] | undefined | null,
	completionStatus?: ResolverInputTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ResolverInputTypes["ScormSuccessStatus"] | undefined | null,
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null
};
	["CreateSessionInput"]: {
	name: string,
	modules: Array<ResolverInputTypes["SessionModuleInput"]>,
	progressionMode?: ResolverInputTypes["SessionProgressionMode"] | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	userIds?: Array<ResolverInputTypes["ID"]> | undefined | null
};
	["SessionModuleInput"]: {
	moduleId: ResolverInputTypes["ID"],
	/** Jour civil au format AAAA-MM-JJ */
	unlockAt?: string | undefined | null
};
	["UpdateSessionInput"]: {
	name?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	status?: ResolverInputTypes["SessionStatus"] | undefined | null,
	progressionMode?: ResolverInputTypes["SessionProgressionMode"] | undefined | null,
	modules?: Array<ResolverInputTypes["SessionModuleInput"]> | undefined | null,
	userIds?: Array<ResolverInputTypes["ID"]> | undefined | null
};
	["RequestTrialInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	orgName: string,
	phone?: string | undefined | null,
	jobTitle?: string | undefined | null
};
	["UpdateCertificateTemplateInput"]: {
	title?: string | undefined | null,
	body?: string | undefined | null,
	signature?: string | undefined | null,
	showScore?: boolean | undefined | null,
	showDate?: boolean | undefined | null,
	showTotalTime?: boolean | undefined | null,
	logo?: string | undefined | null,
	orientation?: ResolverInputTypes["CertificateOrientation"] | undefined | null,
	skeletonPdf?: string | undefined | null,
	marginTop?: number | undefined | null,
	marginBottom?: number | undefined | null,
	marginLeft?: number | undefined | null,
	marginRight?: number | undefined | null
};
	["CreateOrganizationInput"]: {
	name: string,
	slug: string,
	adminEmail: string,
	adminFirstName: string,
	adminLastName: string
};
	["UpdateOrganizationInput"]: {
	id: ResolverInputTypes["ID"],
	name?: string | undefined | null,
	slug?: string | undefined | null,
	status?: ResolverInputTypes["OrganizationStatus"] | undefined | null
};
	["InviteOrgMemberInput"]: {
	orgId: ResolverInputTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	role: ResolverInputTypes["RoleEnum"]
};
	["UpdateReminderSettingsInput"]: {
	enabled?: boolean | undefined | null,
	firstDelayDays?: number | undefined | null,
	frequencyDays?: number | undefined | null,
	maxReminders?: number | undefined | null,
	sendHour?: number | undefined | null,
	subject?: string | undefined | null,
	body?: string | undefined | null
};
	["Subscription"]: AliasType<{
basicSubscription?: [{	email: string},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["schema"]: AliasType<{
	query?:ResolverInputTypes["Query"],
	mutation?:ResolverInputTypes["Mutation"],
	subscription?:ResolverInputTypes["Subscription"],
		__typename?: boolean | `@${string}`
}>;
	["ID"]:unknown
  }

export type ModelTypes = {
    ["Permissions"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	roles: Array<ModelTypes["Role"]>
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:any;
	["UserGroupModel"]: {
		id: ModelTypes["ID"],
	name: string
};
	["Users"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	status: ModelTypes["AccountStatus"],
	email: string,
	password: string,
	passwordResetToken?: string | undefined | null,
	passwordResetExpiryDate?: ModelTypes["DateTime"] | undefined | null,
	activateAccountToken?: string | undefined | null,
	activateAccountExpiryDate?: ModelTypes["DateTime"] | undefined | null,
	emailVerified: boolean,
	verifyEmailToken?: string | undefined | null,
	verifyEmailExpiryDate?: ModelTypes["DateTime"] | undefined | null,
	firstName: string,
	lastName: string,
	refreshToken?: string | undefined | null,
	role: ModelTypes["Role"],
	roleId: string,
	groups?: Array<ModelTypes["UserGroupModel"]> | undefined | null,
	progress?: ModelTypes["UserProgress"] | undefined | null
};
	["AccountStatus"]:AccountStatus;
	["UserProgress"]:UserProgress;
	["UserPagination"]: {
		users: Array<ModelTypes["Users"] | undefined | null>,
	total: number
};
	["ImportUserError"]: {
		line: number,
	email: string,
	reason: string
};
	["ImportUsersReport"]: {
		createdCount: number,
	errorCount: number,
	errors: Array<ModelTypes["ImportUserError"]>
};
	["Role"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	permissions: Array<ModelTypes["Permissions"] | undefined | null>,
	users: Array<ModelTypes["Users"] | undefined | null>
};
	["LearnerCountersModel"]: {
		orgId: ModelTypes["ID"],
	orgName: string,
	orgSlug: string,
	month: string,
	monthlyActive: number,
	learnerCount: number,
	registeredLearners: number,
	leavingWithinThreeMonths: number,
	subscribedTier: ModelTypes["BillingTier"],
	effectiveTier: ModelTypes["BillingTier"],
	billedTier: ModelTypes["BillingTier"],
	placesRemaining?: number | undefined | null,
	nextTier?: ModelTypes["BillingTier"] | undefined | null,
	paymentTerm: ModelTypes["BillingPaymentTerm"],
	estimatedRevenueCents: number
};
	["BillingTier"]:BillingTier;
	["BillingPaymentTerm"]:BillingPaymentTerm;
	["BillingAccountModel"]: {
		id: ModelTypes["ID"],
	tier: ModelTypes["BillingTier"],
	paymentTerm: ModelTypes["BillingPaymentTerm"],
	tierChangedAt?: ModelTypes["DateTime"] | undefined | null,
	companyName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	postalCode?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	vatNumber?: string | undefined | null,
	billingEmail?: string | undefined | null
};
	["BillingEstimateModel"]: {
		month: string,
	subscribedTier: ModelTypes["BillingTier"],
	effectiveTier: ModelTypes["BillingTier"],
	billedTier: ModelTypes["BillingTier"],
	paymentTerm: ModelTypes["BillingPaymentTerm"],
	learnerCount: number,
	monthlyActive: number,
	registeredLearners: number,
	placesRemaining?: number | undefined | null,
	nextTier?: ModelTypes["BillingTier"] | undefined | null,
	leavingWithinThreeMonths: number,
	monthlyPriceCents?: number | undefined | null,
	monthlyAmountCents?: number | undefined | null,
	upfrontYearlyAmountCents?: number | undefined | null,
	isCustom: boolean
};
	["PlanCapabilitiesModel"]: {
		tier: ModelTypes["BillingTier"],
	canCustomizeBranding: boolean,
	canUseSso: boolean
};
	["BillingHistoryEntryModel"]: {
		month: string,
	monthlyActive: number,
	learnerCount: number,
	tier: ModelTypes["BillingTier"],
	amountCents: number
};
	["AppConfigModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	appName: string,
	logo?: string | undefined | null,
	favicon?: string | undefined | null,
	primaryColor?: string | undefined | null,
	accentColor?: string | undefined | null,
	headingFont?: string | undefined | null,
	bodyFont?: string | undefined | null,
	footerText?: string | undefined | null,
	defaultLocale: string,
	timezone: string,
	brandingLocked: boolean,
	signupCtaVisible: boolean
};
	["UniqueAuth"]: {
		access_token: string,
	refresh_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email: string,
	id: string
};
	["UserInfo"]: {
		firstName: string,
	lastName: string,
	roles: ModelTypes["RoleEnum"],
	email: string,
	id: string,
	orgId?: string | undefined | null,
	impersonatorId?: string | undefined | null
};
	["RoleEnum"]:RoleEnum;
	["CertificateTemplateModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	title: string,
	body: string,
	signature?: string | undefined | null,
	showScore: boolean,
	showDate: boolean,
	showTotalTime: boolean,
	logo?: string | undefined | null,
	orientation: ModelTypes["CertificateOrientation"],
	hasSkeleton: boolean,
	marginTop: number,
	marginBottom: number,
	marginLeft: number,
	marginRight: number
};
	["CertificateOrientation"]:CertificateOrientation;
	["DownloadFile"]: {
		fileName: string,
	fileMimeType: string,
	url: string
};
	["MyFiles"]: {
		id: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	eTag: string,
	location: string,
	fileName: string,
	fileMimeType: string,
	ownerId: string
};
	["UploadPreSignedUrl"]: {
		url: string,
	id: string
};
	["GroupMemberModel"]: {
		id: ModelTypes["ID"],
	email: string,
	firstName: string,
	lastName: string
};
	["GroupModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	description?: string | undefined | null,
	memberCount: number,
	members: Array<ModelTypes["GroupMemberModel"]>
};
	["HomeCompletionModel"]: {
		sessionId: ModelTypes["ID"],
	sessionName: string,
	moduleId: ModelTypes["ID"],
	moduleTitle: string,
	learners: number
};
	["HomeSessionModel"]: {
		id: ModelTypes["ID"],
	name: string,
	startDate?: ModelTypes["DateTime"] | undefined | null,
	endDate?: ModelTypes["DateTime"] | undefined | null,
	enrolledLearners: number,
	pendingLearners: number
};
	["BackOfficeHomeModel"]: {
		firstName: string,
	timezone: string,
	completedToday: Array<ModelTypes["HomeCompletionModel"]>,
	startingSoon: Array<ModelTypes["HomeSessionModel"]>,
	endingSoon: Array<ModelTypes["HomeSessionModel"]>,
	overdue: Array<ModelTypes["HomeSessionModel"]>,
	overdueLearners: number,
	overdueSessions: number,
	neverStartedLearners: number
};
	["Mail"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	key: string,
	to: string,
	data: string
};
	["OrganizationModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	name: string,
	slug: string,
	status: ModelTypes["OrganizationStatus"],
	userCount: number
};
	["OrganizationStatus"]:OrganizationStatus;
	["OrgMemberModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	email: string,
	firstName: string,
	lastName: string,
	role: string,
	status: string
};
	["ReminderSettingsModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	enabled: boolean,
	firstDelayDays: number,
	frequencyDays: number,
	maxReminders: number,
	sendHour: number,
	subject: string,
	body: string
};
	["ReminderTestResultModel"]: {
		sent: boolean,
	to: string
};
	["StorageUsageModel"]: {
		orgId: ModelTypes["ID"],
	orgName?: string | undefined | null,
	orgSlug?: string | undefined | null,
	usedBytes: number,
	quotaBytes?: number | undefined | null,
	remainingBytes?: number | undefined | null,
	plan: ModelTypes["BillingTier"],
	moduleCount: number,
	overQuota: boolean
};
	["ScormModuleModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	title: string,
	description?: string | undefined | null,
	scormVersion?: string | undefined | null,
	launchUrl?: string | undefined | null,
	status: ModelTypes["ScormModuleStatus"],
	sizeBytes: number
};
	["ScormModuleStatus"]:ScormModuleStatus;
	["ScormTrackingModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	completionStatus: ModelTypes["ScormCompletionStatus"],
	successStatus: ModelTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: ModelTypes["DateTime"] | undefined | null,
	userId: string,
	sessionId: string
};
	["ScormCompletionStatus"]:ScormCompletionStatus;
	["ScormSuccessStatus"]:ScormSuccessStatus;
	["ScormTrackingWithUser"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	completionStatus: ModelTypes["ScormCompletionStatus"],
	successStatus: ModelTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: ModelTypes["DateTime"] | undefined | null,
	userId: string,
	userEmail: string,
	userFirstName: string,
	userLastName: string,
	sessionId: string,
	sessionName: string
};
	["ScormTrackingStats"]: {
		total: number,
	completed: number,
	inProgress: number,
	notStarted: number,
	completionUnknown: number,
	neverOpened: number,
	notYetUnlocked: number,
	passed: number,
	failed: number,
	averageScorePercent?: number | undefined | null,
	scoredCount: number,
	averageTimeSeconds?: number | undefined | null,
	timedCount: number
};
	["ScormTrackingPagination"]: {
		trackings: Array<ModelTypes["ScormTrackingWithUser"] | undefined | null>,
	total: number
};
	["SessionUserModel"]: {
		id: ModelTypes["ID"],
	email: string,
	firstName: string,
	lastName: string
};
	["SessionModuleModel"]: {
		id: ModelTypes["ID"],
	position: number,
	unlockAt?: ModelTypes["DateTime"] | undefined | null,
	module: ModelTypes["ScormModuleModel"],
	unlocked?: boolean | undefined | null,
	lockReason?: ModelTypes["ModuleLockReason"] | undefined | null,
	myTracking?: ModelTypes["ScormTrackingModel"] | undefined | null
};
	["ModuleLockReason"]:ModuleLockReason;
	["SessionProgressModel"]: {
		totalModules: number,
	completedModules: number,
	completed: boolean
};
	["SessionModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	startDate?: ModelTypes["DateTime"] | undefined | null,
	endDate?: ModelTypes["DateTime"] | undefined | null,
	status: ModelTypes["SessionStatus"],
	progressionMode: ModelTypes["SessionProgressionMode"],
	module: ModelTypes["ScormModuleModel"],
	modules: Array<ModelTypes["SessionModuleModel"]>,
	enrolledUsers: Array<ModelTypes["SessionUserModel"]>,
	myTracking?: ModelTypes["ScormTrackingModel"] | undefined | null,
	progress?: ModelTypes["SessionProgressModel"] | undefined | null
};
	["SessionStatus"]:SessionStatus;
	["SessionProgressionMode"]:SessionProgressionMode;
	["RequestTrialResult"]: {
		accepted: boolean
};
	["ConfirmTrialResult"]: {
		status: ModelTypes["TrialReviewStatus"],
	email: string,
	slug?: string | undefined | null,
	rejectionReason?: string | undefined | null
};
	["TrialReviewStatus"]:TrialReviewStatus;
	["TrialRequestModel"]: {
		id: ModelTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	orgName: string,
	jobTitle?: string | undefined | null,
	phone?: string | undefined | null,
	createdAt: ModelTypes["DateTime"],
	emailConfirmedAt: ModelTypes["DateTime"]
};
	["ApproveTrialResult"]: {
		slug: string
};
	["SsoOrgSettingsModel"]: {
		enabled: boolean
};
	["SsoPresetModel"]: {
		kind: ModelTypes["SsoProviderKind"],
	protocol: string,
	defaultLabel: string,
	defaultIssuer?: string | undefined | null,
	issuerHint?: string | undefined | null,
	sharedIssuer: boolean
};
	["SsoProviderKind"]:SsoProviderKind;
	["SsoProviderModel"]: {
		id: ModelTypes["ID"],
	kind: ModelTypes["SsoProviderKind"],
	protocol: string,
	label: string,
	enabled: boolean,
	issuer?: string | undefined | null,
	clientId?: string | undefined | null,
	hasClientSecret: boolean,
	entryPoint?: string | undefined | null,
	idpIssuer?: string | undefined | null,
	idpCert?: string | undefined | null,
	allowedDomains: Array<string>,
	requiresAllowedDomains: boolean,
	callbackUrl: string,
	metadataUrl?: string | undefined | null
};
	["PublicSsoProviderModel"]: {
		id: ModelTypes["ID"],
	kind: ModelTypes["SsoProviderKind"],
	label: string,
	loginUrl: string
};
	["Health"]: {
		env: string,
	time: string,
	status: string,
	version: string
};
	["StatsNotice"]: {
		status: ModelTypes["ConsentStatus"],
	acknowledgedAt?: ModelTypes["DateTime"] | undefined | null,
	version?: string | undefined | null,
	currentVersion: string,
	needsAcknowledgement: boolean
};
	["ConsentStatus"]:ConsentStatus;
	["Query"]: {
		getHealthGql: ModelTypes["Health"],
	getRole: ModelTypes["Role"],
	getRoles: Array<ModelTypes["Role"]>,
	getPermission: ModelTypes["Permissions"],
	getPermissions: Array<ModelTypes["Permissions"]>,
	getMail: ModelTypes["Mail"],
	getMails: Array<ModelTypes["Mail"]>,
	appConfig: ModelTypes["AppConfigModel"],
	learnerCounters: ModelTypes["LearnerCountersModel"],
	learnerCountersByOrganization: Array<ModelTypes["LearnerCountersModel"]>,
	billingAccount: ModelTypes["BillingAccountModel"],
	planCapabilities: ModelTypes["PlanCapabilitiesModel"],
	billingEstimate: ModelTypes["BillingEstimateModel"],
	billingHistory: Array<ModelTypes["BillingHistoryEntryModel"]>,
	me: ModelTypes["UserInfo"],
	getUser: ModelTypes["Users"],
	getUsers: Array<ModelTypes["Users"]>,
	getExistingUserEmails: Array<string>,
	getFilteredUsers: ModelTypes["UserPagination"],
	groups: Array<ModelTypes["GroupModel"]>,
	group: ModelTypes["GroupModel"],
	ssoProviders: Array<ModelTypes["PublicSsoProviderModel"]>,
	ssoSettings: ModelTypes["SsoOrgSettingsModel"],
	ssoPresets: Array<ModelTypes["SsoPresetModel"]>,
	ssoProviderConfigs: Array<ModelTypes["SsoProviderModel"]>,
	scormModules: Array<ModelTypes["ScormModuleModel"]>,
	scormModule: ModelTypes["ScormModuleModel"],
	storageUsage: ModelTypes["StorageUsageModel"],
	storageUsageByOrganization: Array<ModelTypes["StorageUsageModel"]>,
	getMyScormTracking?: ModelTypes["ScormTrackingModel"] | undefined | null,
	getScormTrackings: ModelTypes["ScormTrackingPagination"],
	getScormTrackingStats: ModelTypes["ScormTrackingStats"],
	sessions: Array<ModelTypes["SessionModel"]>,
	session: ModelTypes["SessionModel"],
	userSessions: Array<ModelTypes["SessionModel"]>,
	mySessions: Array<ModelTypes["SessionModel"]>,
	pendingTrialRequests: Array<ModelTypes["TrialRequestModel"]>,
	backOfficeHome: ModelTypes["BackOfficeHomeModel"],
	certificateTemplate: ModelTypes["CertificateTemplateModel"],
	downloadFile: ModelTypes["DownloadFile"],
	getAllMyFiles: Array<ModelTypes["MyFiles"]>,
	publishBasicSubscription: boolean,
	myStatsNotice: ModelTypes["StatsNotice"],
	organizations: Array<ModelTypes["OrganizationModel"]>,
	organizationMembers: Array<ModelTypes["OrgMemberModel"]>,
	reminderSettings: ModelTypes["ReminderSettingsModel"]
};
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ModelTypes["UserOrderByInput"] | undefined | null,
	filterBy?: ModelTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
	email?: ModelTypes["OrderByEnum"] | undefined | null,
	firstName?: ModelTypes["OrderByEnum"] | undefined | null,
	lastName?: ModelTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: ModelTypes["OrderByEnum"] | undefined | null,
	role?: ModelTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<string> | undefined | null,
	group?: Array<ModelTypes["ID"]> | undefined | null,
	progress?: ModelTypes["UserProgress"] | undefined | null
};
	["FindManyScormTrackingWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput?: string | undefined | null,
	orderBy?: ModelTypes["ScormTrackingOrderByInput"] | undefined | null,
	filterBy?: ModelTypes["ScormTrackingFilterByInput"] | undefined | null
};
	["ScormTrackingOrderByInput"]: {
	userEmail?: ModelTypes["OrderByEnum"] | undefined | null,
	userFirstName?: ModelTypes["OrderByEnum"] | undefined | null,
	userLastName?: ModelTypes["OrderByEnum"] | undefined | null,
	completionStatus?: ModelTypes["OrderByEnum"] | undefined | null,
	successStatus?: ModelTypes["OrderByEnum"] | undefined | null,
	scoreRaw?: ModelTypes["OrderByEnum"] | undefined | null,
	completedAt?: ModelTypes["OrderByEnum"] | undefined | null
};
	["ScormTrackingFilterByInput"]: {
	completionStatus?: ModelTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ModelTypes["ScormSuccessStatus"] | undefined | null,
	sessionId?: ModelTypes["ID"] | undefined | null,
	groupId?: ModelTypes["ID"] | undefined | null
};
	["ScormTrackingStatsInput"]: {
	searchInput?: string | undefined | null,
	filterBy?: ModelTypes["ScormStatsScopeInput"] | undefined | null
};
	["ScormStatsScopeInput"]: {
	sessionId?: ModelTypes["ID"] | undefined | null,
	groupId?: ModelTypes["ID"] | undefined | null
};
	["Mutation"]: {
		updateAppConfig: ModelTypes["AppConfigModel"],
	updateBillingProfile: ModelTypes["BillingAccountModel"],
	changeBillingPlan: ModelTypes["BillingAccountModel"],
	login: ModelTypes["AuthType"],
	requestMagicLink: boolean,
	loginWithMagicLink: ModelTypes["AuthType"],
	askForResetPassword: boolean,
	reSendEmailValidation: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	finishRegister: boolean,
	refresh: ModelTypes["AuthType"],
	logout: boolean,
	uniqueAuthFromSso: ModelTypes["UniqueAuth"],
	impersonateUser: ModelTypes["AuthType"],
	stopImpersonate: ModelTypes["AuthType"],
	createUser: ModelTypes["Users"],
	importUsers: ModelTypes["ImportUsersReport"],
	updateUser: ModelTypes["Users"],
	deleteUser: boolean,
	createGroup: ModelTypes["GroupModel"],
	updateGroup: ModelTypes["GroupModel"],
	deleteGroup: boolean,
	addUsersToGroup: number,
	removeUsersFromGroup: number,
	setSsoEnabled: ModelTypes["SsoOrgSettingsModel"],
	upsertSsoProvider: ModelTypes["SsoProviderModel"],
	deleteSsoProvider: boolean,
	deleteScormModule: boolean,
	upsertScormTracking: ModelTypes["ScormTrackingModel"],
	createSession: ModelTypes["SessionModel"],
	updateSession: ModelTypes["SessionModel"],
	deleteSession: boolean,
	requestTrialOrganization: ModelTypes["RequestTrialResult"],
	confirmTrialOrganization: ModelTypes["ConfirmTrialResult"],
	approveTrialRequest: ModelTypes["ApproveTrialResult"],
	rejectTrialRequest: boolean,
	updateCertificateTemplate: ModelTypes["CertificateTemplateModel"],
	deleteFile: boolean,
	uploadPreSignedUrl: ModelTypes["UploadPreSignedUrl"],
	confirmUpload: boolean,
	acknowledgeStatsNotice: ModelTypes["StatsNotice"],
	createOrganization: ModelTypes["OrganizationModel"],
	setOrganizationStatus: ModelTypes["OrganizationModel"],
	updateOrganization: ModelTypes["OrganizationModel"],
	deleteOrganization: boolean,
	inviteOrgMember: ModelTypes["OrgMemberModel"],
	removeOrgMember: boolean,
	updateReminderSettings: ModelTypes["ReminderSettingsModel"],
	sendReminderTest: ModelTypes["ReminderTestResultModel"]
};
	["UpdateAppConfigInput"]: {
	appName?: string | undefined | null,
	logo?: string | undefined | null,
	favicon?: string | undefined | null,
	primaryColor?: string | undefined | null,
	accentColor?: string | undefined | null,
	headingFont?: string | undefined | null,
	bodyFont?: string | undefined | null,
	footerText?: string | undefined | null,
	defaultLocale?: string | undefined | null
};
	["UpdateBillingProfileInput"]: {
	companyName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	postalCode?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	vatNumber?: string | undefined | null,
	billingEmail?: string | undefined | null
};
	["ChangeBillingPlanInput"]: {
	tier: ModelTypes["BillingTier"],
	paymentTerm?: ModelTypes["BillingPaymentTerm"] | undefined | null
};
	["AuthType"]:ModelTypes["UserInfo"] | ModelTypes["CustomError"];
	["CustomError"]: {
		error: ModelTypes["EError"],
	message: string
};
	["EError"]:EError;
	["CreateUserInput"]: {
	email: string,
	password?: string | undefined | null,
	firstName: string,
	lastName: string,
	roleId: string,
	group?: string | undefined | null
};
	["ImportUserInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	group?: string | undefined | null
};
	["UpdateUserInput"]: {
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: string | undefined | null,
	id: string
};
	["CreateGroupInput"]: {
	name: string,
	description?: string | undefined | null,
	userIds?: Array<ModelTypes["ID"]> | undefined | null
};
	["UpdateGroupInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	userIds?: Array<ModelTypes["ID"]> | undefined | null
};
	["UpsertSsoProviderInput"]: {
	kind: ModelTypes["SsoProviderKind"],
	label?: string | undefined | null,
	enabled?: boolean | undefined | null,
	issuer?: string | undefined | null,
	clientId?: string | undefined | null,
	clientSecret?: string | undefined | null,
	entryPoint?: string | undefined | null,
	idpIssuer?: string | undefined | null,
	idpCert?: string | undefined | null,
	allowedDomains?: Array<string> | undefined | null
};
	["UpsertScormTrackingInput"]: {
	sessionId: ModelTypes["ID"],
	moduleId?: ModelTypes["ID"] | undefined | null,
	completionStatus?: ModelTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ModelTypes["ScormSuccessStatus"] | undefined | null,
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null
};
	["CreateSessionInput"]: {
	name: string,
	modules: Array<ModelTypes["SessionModuleInput"]>,
	progressionMode?: ModelTypes["SessionProgressionMode"] | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	userIds?: Array<ModelTypes["ID"]> | undefined | null
};
	["SessionModuleInput"]: {
	moduleId: ModelTypes["ID"],
	/** Jour civil au format AAAA-MM-JJ */
	unlockAt?: string | undefined | null
};
	["UpdateSessionInput"]: {
	name?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	status?: ModelTypes["SessionStatus"] | undefined | null,
	progressionMode?: ModelTypes["SessionProgressionMode"] | undefined | null,
	modules?: Array<ModelTypes["SessionModuleInput"]> | undefined | null,
	userIds?: Array<ModelTypes["ID"]> | undefined | null
};
	["RequestTrialInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	orgName: string,
	phone?: string | undefined | null,
	jobTitle?: string | undefined | null
};
	["UpdateCertificateTemplateInput"]: {
	title?: string | undefined | null,
	body?: string | undefined | null,
	signature?: string | undefined | null,
	showScore?: boolean | undefined | null,
	showDate?: boolean | undefined | null,
	showTotalTime?: boolean | undefined | null,
	logo?: string | undefined | null,
	orientation?: ModelTypes["CertificateOrientation"] | undefined | null,
	skeletonPdf?: string | undefined | null,
	marginTop?: number | undefined | null,
	marginBottom?: number | undefined | null,
	marginLeft?: number | undefined | null,
	marginRight?: number | undefined | null
};
	["CreateOrganizationInput"]: {
	name: string,
	slug: string,
	adminEmail: string,
	adminFirstName: string,
	adminLastName: string
};
	["UpdateOrganizationInput"]: {
	id: ModelTypes["ID"],
	name?: string | undefined | null,
	slug?: string | undefined | null,
	status?: ModelTypes["OrganizationStatus"] | undefined | null
};
	["InviteOrgMemberInput"]: {
	orgId: ModelTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	role: ModelTypes["RoleEnum"]
};
	["UpdateReminderSettingsInput"]: {
	enabled?: boolean | undefined | null,
	firstDelayDays?: number | undefined | null,
	frequencyDays?: number | undefined | null,
	maxReminders?: number | undefined | null,
	sendHour?: number | undefined | null,
	subject?: string | undefined | null,
	body?: string | undefined | null
};
	["Subscription"]: {
		basicSubscription?: string | undefined | null
};
	["schema"]: {
	query?: ModelTypes["Query"] | undefined | null,
	mutation?: ModelTypes["Mutation"] | undefined | null,
	subscription?: ModelTypes["Subscription"] | undefined | null
};
	["ID"]:any
    }

export type GraphQLTypes = {
    // ------------------------------------------------------;
	// THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY);
	// ------------------------------------------------------;
	["Permissions"]: {
	__typename: "Permissions",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	roles: Array<GraphQLTypes["Role"]>,
	['...on Permissions']: Omit<GraphQLTypes["Permissions"], "...on Permissions">
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]: "scalar" & { name: "DateTime" };
	["UserGroupModel"]: {
	__typename: "UserGroupModel",
	id: GraphQLTypes["ID"],
	name: string,
	['...on UserGroupModel']: Omit<GraphQLTypes["UserGroupModel"], "...on UserGroupModel">
};
	["Users"]: {
	__typename: "Users",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	status: GraphQLTypes["AccountStatus"],
	email: string,
	password: string,
	passwordResetToken?: string | undefined | null,
	passwordResetExpiryDate?: GraphQLTypes["DateTime"] | undefined | null,
	activateAccountToken?: string | undefined | null,
	activateAccountExpiryDate?: GraphQLTypes["DateTime"] | undefined | null,
	emailVerified: boolean,
	verifyEmailToken?: string | undefined | null,
	verifyEmailExpiryDate?: GraphQLTypes["DateTime"] | undefined | null,
	firstName: string,
	lastName: string,
	refreshToken?: string | undefined | null,
	role: GraphQLTypes["Role"],
	roleId: string,
	groups?: Array<GraphQLTypes["UserGroupModel"]> | undefined | null,
	progress?: GraphQLTypes["UserProgress"] | undefined | null,
	['...on Users']: Omit<GraphQLTypes["Users"], "...on Users">
};
	["AccountStatus"]: AccountStatus;
	["UserProgress"]: UserProgress;
	["UserPagination"]: {
	__typename: "UserPagination",
	users: Array<GraphQLTypes["Users"] | undefined | null>,
	total: number,
	['...on UserPagination']: Omit<GraphQLTypes["UserPagination"], "...on UserPagination">
};
	["ImportUserError"]: {
	__typename: "ImportUserError",
	line: number,
	email: string,
	reason: string,
	['...on ImportUserError']: Omit<GraphQLTypes["ImportUserError"], "...on ImportUserError">
};
	["ImportUsersReport"]: {
	__typename: "ImportUsersReport",
	createdCount: number,
	errorCount: number,
	errors: Array<GraphQLTypes["ImportUserError"]>,
	['...on ImportUsersReport']: Omit<GraphQLTypes["ImportUsersReport"], "...on ImportUsersReport">
};
	["Role"]: {
	__typename: "Role",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	permissions: Array<GraphQLTypes["Permissions"] | undefined | null>,
	users: Array<GraphQLTypes["Users"] | undefined | null>,
	['...on Role']: Omit<GraphQLTypes["Role"], "...on Role">
};
	["LearnerCountersModel"]: {
	__typename: "LearnerCountersModel",
	orgId: GraphQLTypes["ID"],
	orgName: string,
	orgSlug: string,
	month: string,
	monthlyActive: number,
	learnerCount: number,
	registeredLearners: number,
	leavingWithinThreeMonths: number,
	subscribedTier: GraphQLTypes["BillingTier"],
	effectiveTier: GraphQLTypes["BillingTier"],
	billedTier: GraphQLTypes["BillingTier"],
	placesRemaining?: number | undefined | null,
	nextTier?: GraphQLTypes["BillingTier"] | undefined | null,
	paymentTerm: GraphQLTypes["BillingPaymentTerm"],
	estimatedRevenueCents: number,
	['...on LearnerCountersModel']: Omit<GraphQLTypes["LearnerCountersModel"], "...on LearnerCountersModel">
};
	["BillingTier"]: BillingTier;
	["BillingPaymentTerm"]: BillingPaymentTerm;
	["BillingAccountModel"]: {
	__typename: "BillingAccountModel",
	id: GraphQLTypes["ID"],
	tier: GraphQLTypes["BillingTier"],
	paymentTerm: GraphQLTypes["BillingPaymentTerm"],
	tierChangedAt?: GraphQLTypes["DateTime"] | undefined | null,
	companyName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	postalCode?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	vatNumber?: string | undefined | null,
	billingEmail?: string | undefined | null,
	['...on BillingAccountModel']: Omit<GraphQLTypes["BillingAccountModel"], "...on BillingAccountModel">
};
	["BillingEstimateModel"]: {
	__typename: "BillingEstimateModel",
	month: string,
	subscribedTier: GraphQLTypes["BillingTier"],
	effectiveTier: GraphQLTypes["BillingTier"],
	billedTier: GraphQLTypes["BillingTier"],
	paymentTerm: GraphQLTypes["BillingPaymentTerm"],
	learnerCount: number,
	monthlyActive: number,
	registeredLearners: number,
	placesRemaining?: number | undefined | null,
	nextTier?: GraphQLTypes["BillingTier"] | undefined | null,
	leavingWithinThreeMonths: number,
	monthlyPriceCents?: number | undefined | null,
	monthlyAmountCents?: number | undefined | null,
	upfrontYearlyAmountCents?: number | undefined | null,
	isCustom: boolean,
	['...on BillingEstimateModel']: Omit<GraphQLTypes["BillingEstimateModel"], "...on BillingEstimateModel">
};
	["PlanCapabilitiesModel"]: {
	__typename: "PlanCapabilitiesModel",
	tier: GraphQLTypes["BillingTier"],
	canCustomizeBranding: boolean,
	canUseSso: boolean,
	['...on PlanCapabilitiesModel']: Omit<GraphQLTypes["PlanCapabilitiesModel"], "...on PlanCapabilitiesModel">
};
	["BillingHistoryEntryModel"]: {
	__typename: "BillingHistoryEntryModel",
	month: string,
	monthlyActive: number,
	learnerCount: number,
	tier: GraphQLTypes["BillingTier"],
	amountCents: number,
	['...on BillingHistoryEntryModel']: Omit<GraphQLTypes["BillingHistoryEntryModel"], "...on BillingHistoryEntryModel">
};
	["AppConfigModel"]: {
	__typename: "AppConfigModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	appName: string,
	logo?: string | undefined | null,
	favicon?: string | undefined | null,
	primaryColor?: string | undefined | null,
	accentColor?: string | undefined | null,
	headingFont?: string | undefined | null,
	bodyFont?: string | undefined | null,
	footerText?: string | undefined | null,
	defaultLocale: string,
	timezone: string,
	brandingLocked: boolean,
	signupCtaVisible: boolean,
	['...on AppConfigModel']: Omit<GraphQLTypes["AppConfigModel"], "...on AppConfigModel">
};
	["UniqueAuth"]: {
	__typename: "UniqueAuth",
	access_token: string,
	refresh_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email: string,
	id: string,
	['...on UniqueAuth']: Omit<GraphQLTypes["UniqueAuth"], "...on UniqueAuth">
};
	["UserInfo"]: {
	__typename: "UserInfo",
	firstName: string,
	lastName: string,
	roles: GraphQLTypes["RoleEnum"],
	email: string,
	id: string,
	orgId?: string | undefined | null,
	impersonatorId?: string | undefined | null,
	['...on UserInfo']: Omit<GraphQLTypes["UserInfo"], "...on UserInfo">
};
	["RoleEnum"]: RoleEnum;
	["CertificateTemplateModel"]: {
	__typename: "CertificateTemplateModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	title: string,
	body: string,
	signature?: string | undefined | null,
	showScore: boolean,
	showDate: boolean,
	showTotalTime: boolean,
	logo?: string | undefined | null,
	orientation: GraphQLTypes["CertificateOrientation"],
	hasSkeleton: boolean,
	marginTop: number,
	marginBottom: number,
	marginLeft: number,
	marginRight: number,
	['...on CertificateTemplateModel']: Omit<GraphQLTypes["CertificateTemplateModel"], "...on CertificateTemplateModel">
};
	["CertificateOrientation"]: CertificateOrientation;
	["DownloadFile"]: {
	__typename: "DownloadFile",
	fileName: string,
	fileMimeType: string,
	url: string,
	['...on DownloadFile']: Omit<GraphQLTypes["DownloadFile"], "...on DownloadFile">
};
	["MyFiles"]: {
	__typename: "MyFiles",
	id: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	eTag: string,
	location: string,
	fileName: string,
	fileMimeType: string,
	ownerId: string,
	['...on MyFiles']: Omit<GraphQLTypes["MyFiles"], "...on MyFiles">
};
	["UploadPreSignedUrl"]: {
	__typename: "UploadPreSignedUrl",
	url: string,
	id: string,
	['...on UploadPreSignedUrl']: Omit<GraphQLTypes["UploadPreSignedUrl"], "...on UploadPreSignedUrl">
};
	["GroupMemberModel"]: {
	__typename: "GroupMemberModel",
	id: GraphQLTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	['...on GroupMemberModel']: Omit<GraphQLTypes["GroupMemberModel"], "...on GroupMemberModel">
};
	["GroupModel"]: {
	__typename: "GroupModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	description?: string | undefined | null,
	memberCount: number,
	members: Array<GraphQLTypes["GroupMemberModel"]>,
	['...on GroupModel']: Omit<GraphQLTypes["GroupModel"], "...on GroupModel">
};
	["HomeCompletionModel"]: {
	__typename: "HomeCompletionModel",
	sessionId: GraphQLTypes["ID"],
	sessionName: string,
	moduleId: GraphQLTypes["ID"],
	moduleTitle: string,
	learners: number,
	['...on HomeCompletionModel']: Omit<GraphQLTypes["HomeCompletionModel"], "...on HomeCompletionModel">
};
	["HomeSessionModel"]: {
	__typename: "HomeSessionModel",
	id: GraphQLTypes["ID"],
	name: string,
	startDate?: GraphQLTypes["DateTime"] | undefined | null,
	endDate?: GraphQLTypes["DateTime"] | undefined | null,
	enrolledLearners: number,
	pendingLearners: number,
	['...on HomeSessionModel']: Omit<GraphQLTypes["HomeSessionModel"], "...on HomeSessionModel">
};
	["BackOfficeHomeModel"]: {
	__typename: "BackOfficeHomeModel",
	firstName: string,
	timezone: string,
	completedToday: Array<GraphQLTypes["HomeCompletionModel"]>,
	startingSoon: Array<GraphQLTypes["HomeSessionModel"]>,
	endingSoon: Array<GraphQLTypes["HomeSessionModel"]>,
	overdue: Array<GraphQLTypes["HomeSessionModel"]>,
	overdueLearners: number,
	overdueSessions: number,
	neverStartedLearners: number,
	['...on BackOfficeHomeModel']: Omit<GraphQLTypes["BackOfficeHomeModel"], "...on BackOfficeHomeModel">
};
	["Mail"]: {
	__typename: "Mail",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	key: string,
	to: string,
	data: string,
	['...on Mail']: Omit<GraphQLTypes["Mail"], "...on Mail">
};
	["OrganizationModel"]: {
	__typename: "OrganizationModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	name: string,
	slug: string,
	status: GraphQLTypes["OrganizationStatus"],
	userCount: number,
	['...on OrganizationModel']: Omit<GraphQLTypes["OrganizationModel"], "...on OrganizationModel">
};
	["OrganizationStatus"]: OrganizationStatus;
	["OrgMemberModel"]: {
	__typename: "OrgMemberModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	email: string,
	firstName: string,
	lastName: string,
	role: string,
	status: string,
	['...on OrgMemberModel']: Omit<GraphQLTypes["OrgMemberModel"], "...on OrgMemberModel">
};
	["ReminderSettingsModel"]: {
	__typename: "ReminderSettingsModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	enabled: boolean,
	firstDelayDays: number,
	frequencyDays: number,
	maxReminders: number,
	sendHour: number,
	subject: string,
	body: string,
	['...on ReminderSettingsModel']: Omit<GraphQLTypes["ReminderSettingsModel"], "...on ReminderSettingsModel">
};
	["ReminderTestResultModel"]: {
	__typename: "ReminderTestResultModel",
	sent: boolean,
	to: string,
	['...on ReminderTestResultModel']: Omit<GraphQLTypes["ReminderTestResultModel"], "...on ReminderTestResultModel">
};
	["StorageUsageModel"]: {
	__typename: "StorageUsageModel",
	orgId: GraphQLTypes["ID"],
	orgName?: string | undefined | null,
	orgSlug?: string | undefined | null,
	usedBytes: number,
	quotaBytes?: number | undefined | null,
	remainingBytes?: number | undefined | null,
	plan: GraphQLTypes["BillingTier"],
	moduleCount: number,
	overQuota: boolean,
	['...on StorageUsageModel']: Omit<GraphQLTypes["StorageUsageModel"], "...on StorageUsageModel">
};
	["ScormModuleModel"]: {
	__typename: "ScormModuleModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	title: string,
	description?: string | undefined | null,
	scormVersion?: string | undefined | null,
	launchUrl?: string | undefined | null,
	status: GraphQLTypes["ScormModuleStatus"],
	sizeBytes: number,
	['...on ScormModuleModel']: Omit<GraphQLTypes["ScormModuleModel"], "...on ScormModuleModel">
};
	["ScormModuleStatus"]: ScormModuleStatus;
	["ScormTrackingModel"]: {
	__typename: "ScormTrackingModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	completionStatus: GraphQLTypes["ScormCompletionStatus"],
	successStatus: GraphQLTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: GraphQLTypes["DateTime"] | undefined | null,
	userId: string,
	sessionId: string,
	['...on ScormTrackingModel']: Omit<GraphQLTypes["ScormTrackingModel"], "...on ScormTrackingModel">
};
	["ScormCompletionStatus"]: ScormCompletionStatus;
	["ScormSuccessStatus"]: ScormSuccessStatus;
	["ScormTrackingWithUser"]: {
	__typename: "ScormTrackingWithUser",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	completionStatus: GraphQLTypes["ScormCompletionStatus"],
	successStatus: GraphQLTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: GraphQLTypes["DateTime"] | undefined | null,
	userId: string,
	userEmail: string,
	userFirstName: string,
	userLastName: string,
	sessionId: string,
	sessionName: string,
	['...on ScormTrackingWithUser']: Omit<GraphQLTypes["ScormTrackingWithUser"], "...on ScormTrackingWithUser">
};
	["ScormTrackingStats"]: {
	__typename: "ScormTrackingStats",
	total: number,
	completed: number,
	inProgress: number,
	notStarted: number,
	completionUnknown: number,
	neverOpened: number,
	notYetUnlocked: number,
	passed: number,
	failed: number,
	averageScorePercent?: number | undefined | null,
	scoredCount: number,
	averageTimeSeconds?: number | undefined | null,
	timedCount: number,
	['...on ScormTrackingStats']: Omit<GraphQLTypes["ScormTrackingStats"], "...on ScormTrackingStats">
};
	["ScormTrackingPagination"]: {
	__typename: "ScormTrackingPagination",
	trackings: Array<GraphQLTypes["ScormTrackingWithUser"] | undefined | null>,
	total: number,
	['...on ScormTrackingPagination']: Omit<GraphQLTypes["ScormTrackingPagination"], "...on ScormTrackingPagination">
};
	["SessionUserModel"]: {
	__typename: "SessionUserModel",
	id: GraphQLTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	['...on SessionUserModel']: Omit<GraphQLTypes["SessionUserModel"], "...on SessionUserModel">
};
	["SessionModuleModel"]: {
	__typename: "SessionModuleModel",
	id: GraphQLTypes["ID"],
	position: number,
	unlockAt?: GraphQLTypes["DateTime"] | undefined | null,
	module: GraphQLTypes["ScormModuleModel"],
	unlocked?: boolean | undefined | null,
	lockReason?: GraphQLTypes["ModuleLockReason"] | undefined | null,
	myTracking?: GraphQLTypes["ScormTrackingModel"] | undefined | null,
	['...on SessionModuleModel']: Omit<GraphQLTypes["SessionModuleModel"], "...on SessionModuleModel">
};
	/** Pourquoi un module est fermé — une date à attendre, ou un module à finir. */
["ModuleLockReason"]: ModuleLockReason;
	["SessionProgressModel"]: {
	__typename: "SessionProgressModel",
	totalModules: number,
	completedModules: number,
	completed: boolean,
	['...on SessionProgressModel']: Omit<GraphQLTypes["SessionProgressModel"], "...on SessionProgressModel">
};
	["SessionModel"]: {
	__typename: "SessionModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	startDate?: GraphQLTypes["DateTime"] | undefined | null,
	endDate?: GraphQLTypes["DateTime"] | undefined | null,
	status: GraphQLTypes["SessionStatus"],
	progressionMode: GraphQLTypes["SessionProgressionMode"],
	module: GraphQLTypes["ScormModuleModel"],
	modules: Array<GraphQLTypes["SessionModuleModel"]>,
	enrolledUsers: Array<GraphQLTypes["SessionUserModel"]>,
	myTracking?: GraphQLTypes["ScormTrackingModel"] | undefined | null,
	progress?: GraphQLTypes["SessionProgressModel"] | undefined | null,
	['...on SessionModel']: Omit<GraphQLTypes["SessionModel"], "...on SessionModel">
};
	["SessionStatus"]: SessionStatus;
	/** Règle d'enchaînement du parcours. Le déblocage par date n'est pas une valeur ici : c'est un second verrou, porté par SessionModule.unlockAt. */
["SessionProgressionMode"]: SessionProgressionMode;
	["RequestTrialResult"]: {
	__typename: "RequestTrialResult",
	accepted: boolean,
	['...on RequestTrialResult']: Omit<GraphQLTypes["RequestTrialResult"], "...on RequestTrialResult">
};
	["ConfirmTrialResult"]: {
	__typename: "ConfirmTrialResult",
	status: GraphQLTypes["TrialReviewStatus"],
	email: string,
	slug?: string | undefined | null,
	rejectionReason?: string | undefined | null,
	['...on ConfirmTrialResult']: Omit<GraphQLTypes["ConfirmTrialResult"], "...on ConfirmTrialResult">
};
	["TrialReviewStatus"]: TrialReviewStatus;
	["TrialRequestModel"]: {
	__typename: "TrialRequestModel",
	id: GraphQLTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	orgName: string,
	jobTitle?: string | undefined | null,
	phone?: string | undefined | null,
	createdAt: GraphQLTypes["DateTime"],
	emailConfirmedAt: GraphQLTypes["DateTime"],
	['...on TrialRequestModel']: Omit<GraphQLTypes["TrialRequestModel"], "...on TrialRequestModel">
};
	["ApproveTrialResult"]: {
	__typename: "ApproveTrialResult",
	slug: string,
	['...on ApproveTrialResult']: Omit<GraphQLTypes["ApproveTrialResult"], "...on ApproveTrialResult">
};
	["SsoOrgSettingsModel"]: {
	__typename: "SsoOrgSettingsModel",
	enabled: boolean,
	['...on SsoOrgSettingsModel']: Omit<GraphQLTypes["SsoOrgSettingsModel"], "...on SsoOrgSettingsModel">
};
	["SsoPresetModel"]: {
	__typename: "SsoPresetModel",
	kind: GraphQLTypes["SsoProviderKind"],
	protocol: string,
	defaultLabel: string,
	defaultIssuer?: string | undefined | null,
	issuerHint?: string | undefined | null,
	sharedIssuer: boolean,
	['...on SsoPresetModel']: Omit<GraphQLTypes["SsoPresetModel"], "...on SsoPresetModel">
};
	/** Fournisseur d'identité pré-listé (#40). */
["SsoProviderKind"]: SsoProviderKind;
	["SsoProviderModel"]: {
	__typename: "SsoProviderModel",
	id: GraphQLTypes["ID"],
	kind: GraphQLTypes["SsoProviderKind"],
	protocol: string,
	label: string,
	enabled: boolean,
	issuer?: string | undefined | null,
	clientId?: string | undefined | null,
	hasClientSecret: boolean,
	entryPoint?: string | undefined | null,
	idpIssuer?: string | undefined | null,
	idpCert?: string | undefined | null,
	allowedDomains: Array<string>,
	requiresAllowedDomains: boolean,
	callbackUrl: string,
	metadataUrl?: string | undefined | null,
	['...on SsoProviderModel']: Omit<GraphQLTypes["SsoProviderModel"], "...on SsoProviderModel">
};
	["PublicSsoProviderModel"]: {
	__typename: "PublicSsoProviderModel",
	id: GraphQLTypes["ID"],
	kind: GraphQLTypes["SsoProviderKind"],
	label: string,
	loginUrl: string,
	['...on PublicSsoProviderModel']: Omit<GraphQLTypes["PublicSsoProviderModel"], "...on PublicSsoProviderModel">
};
	["Health"]: {
	__typename: "Health",
	env: string,
	time: string,
	status: string,
	version: string,
	['...on Health']: Omit<GraphQLTypes["Health"], "...on Health">
};
	["StatsNotice"]: {
	__typename: "StatsNotice",
	status: GraphQLTypes["ConsentStatus"],
	acknowledgedAt?: GraphQLTypes["DateTime"] | undefined | null,
	version?: string | undefined | null,
	currentVersion: string,
	needsAcknowledgement: boolean,
	['...on StatsNotice']: Omit<GraphQLTypes["StatsNotice"], "...on StatsNotice">
};
	["ConsentStatus"]: ConsentStatus;
	["Query"]: {
	__typename: "Query",
	getHealthGql: GraphQLTypes["Health"],
	getRole: GraphQLTypes["Role"],
	getRoles: Array<GraphQLTypes["Role"]>,
	getPermission: GraphQLTypes["Permissions"],
	getPermissions: Array<GraphQLTypes["Permissions"]>,
	getMail: GraphQLTypes["Mail"],
	getMails: Array<GraphQLTypes["Mail"]>,
	appConfig: GraphQLTypes["AppConfigModel"],
	learnerCounters: GraphQLTypes["LearnerCountersModel"],
	learnerCountersByOrganization: Array<GraphQLTypes["LearnerCountersModel"]>,
	billingAccount: GraphQLTypes["BillingAccountModel"],
	planCapabilities: GraphQLTypes["PlanCapabilitiesModel"],
	billingEstimate: GraphQLTypes["BillingEstimateModel"],
	billingHistory: Array<GraphQLTypes["BillingHistoryEntryModel"]>,
	me: GraphQLTypes["UserInfo"],
	getUser: GraphQLTypes["Users"],
	getUsers: Array<GraphQLTypes["Users"]>,
	getExistingUserEmails: Array<string>,
	getFilteredUsers: GraphQLTypes["UserPagination"],
	groups: Array<GraphQLTypes["GroupModel"]>,
	group: GraphQLTypes["GroupModel"],
	ssoProviders: Array<GraphQLTypes["PublicSsoProviderModel"]>,
	ssoSettings: GraphQLTypes["SsoOrgSettingsModel"],
	ssoPresets: Array<GraphQLTypes["SsoPresetModel"]>,
	ssoProviderConfigs: Array<GraphQLTypes["SsoProviderModel"]>,
	scormModules: Array<GraphQLTypes["ScormModuleModel"]>,
	scormModule: GraphQLTypes["ScormModuleModel"],
	storageUsage: GraphQLTypes["StorageUsageModel"],
	storageUsageByOrganization: Array<GraphQLTypes["StorageUsageModel"]>,
	getMyScormTracking?: GraphQLTypes["ScormTrackingModel"] | undefined | null,
	getScormTrackings: GraphQLTypes["ScormTrackingPagination"],
	getScormTrackingStats: GraphQLTypes["ScormTrackingStats"],
	sessions: Array<GraphQLTypes["SessionModel"]>,
	session: GraphQLTypes["SessionModel"],
	userSessions: Array<GraphQLTypes["SessionModel"]>,
	mySessions: Array<GraphQLTypes["SessionModel"]>,
	pendingTrialRequests: Array<GraphQLTypes["TrialRequestModel"]>,
	backOfficeHome: GraphQLTypes["BackOfficeHomeModel"],
	certificateTemplate: GraphQLTypes["CertificateTemplateModel"],
	downloadFile: GraphQLTypes["DownloadFile"],
	getAllMyFiles: Array<GraphQLTypes["MyFiles"]>,
	publishBasicSubscription: boolean,
	myStatsNotice: GraphQLTypes["StatsNotice"],
	organizations: Array<GraphQLTypes["OrganizationModel"]>,
	organizationMembers: Array<GraphQLTypes["OrgMemberModel"]>,
	reminderSettings: GraphQLTypes["ReminderSettingsModel"],
	['...on Query']: Omit<GraphQLTypes["Query"], "...on Query">
};
	["FindManyUserWithFiltersInput"]: {
		skip: number,
	take: number,
	searchInput: string,
	orderBy?: GraphQLTypes["UserOrderByInput"] | undefined | null,
	filterBy?: GraphQLTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
		email?: GraphQLTypes["OrderByEnum"] | undefined | null,
	firstName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	lastName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: GraphQLTypes["OrderByEnum"] | undefined | null,
	role?: GraphQLTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]: OrderByEnum;
	["UserFilterByInput"]: {
		role?: Array<string> | undefined | null,
	group?: Array<GraphQLTypes["ID"]> | undefined | null,
	progress?: GraphQLTypes["UserProgress"] | undefined | null
};
	["FindManyScormTrackingWithFiltersInput"]: {
		skip: number,
	take: number,
	searchInput?: string | undefined | null,
	orderBy?: GraphQLTypes["ScormTrackingOrderByInput"] | undefined | null,
	filterBy?: GraphQLTypes["ScormTrackingFilterByInput"] | undefined | null
};
	["ScormTrackingOrderByInput"]: {
		userEmail?: GraphQLTypes["OrderByEnum"] | undefined | null,
	userFirstName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	userLastName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	completionStatus?: GraphQLTypes["OrderByEnum"] | undefined | null,
	successStatus?: GraphQLTypes["OrderByEnum"] | undefined | null,
	scoreRaw?: GraphQLTypes["OrderByEnum"] | undefined | null,
	completedAt?: GraphQLTypes["OrderByEnum"] | undefined | null
};
	["ScormTrackingFilterByInput"]: {
		completionStatus?: GraphQLTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: GraphQLTypes["ScormSuccessStatus"] | undefined | null,
	sessionId?: GraphQLTypes["ID"] | undefined | null,
	groupId?: GraphQLTypes["ID"] | undefined | null
};
	["ScormTrackingStatsInput"]: {
		searchInput?: string | undefined | null,
	filterBy?: GraphQLTypes["ScormStatsScopeInput"] | undefined | null
};
	["ScormStatsScopeInput"]: {
		sessionId?: GraphQLTypes["ID"] | undefined | null,
	groupId?: GraphQLTypes["ID"] | undefined | null
};
	["Mutation"]: {
	__typename: "Mutation",
	updateAppConfig: GraphQLTypes["AppConfigModel"],
	updateBillingProfile: GraphQLTypes["BillingAccountModel"],
	changeBillingPlan: GraphQLTypes["BillingAccountModel"],
	login: GraphQLTypes["AuthType"],
	requestMagicLink: boolean,
	loginWithMagicLink: GraphQLTypes["AuthType"],
	askForResetPassword: boolean,
	reSendEmailValidation: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	finishRegister: boolean,
	refresh: GraphQLTypes["AuthType"],
	logout: boolean,
	uniqueAuthFromSso: GraphQLTypes["UniqueAuth"],
	impersonateUser: GraphQLTypes["AuthType"],
	stopImpersonate: GraphQLTypes["AuthType"],
	createUser: GraphQLTypes["Users"],
	importUsers: GraphQLTypes["ImportUsersReport"],
	updateUser: GraphQLTypes["Users"],
	deleteUser: boolean,
	createGroup: GraphQLTypes["GroupModel"],
	updateGroup: GraphQLTypes["GroupModel"],
	deleteGroup: boolean,
	addUsersToGroup: number,
	removeUsersFromGroup: number,
	setSsoEnabled: GraphQLTypes["SsoOrgSettingsModel"],
	upsertSsoProvider: GraphQLTypes["SsoProviderModel"],
	deleteSsoProvider: boolean,
	deleteScormModule: boolean,
	upsertScormTracking: GraphQLTypes["ScormTrackingModel"],
	createSession: GraphQLTypes["SessionModel"],
	updateSession: GraphQLTypes["SessionModel"],
	deleteSession: boolean,
	requestTrialOrganization: GraphQLTypes["RequestTrialResult"],
	confirmTrialOrganization: GraphQLTypes["ConfirmTrialResult"],
	approveTrialRequest: GraphQLTypes["ApproveTrialResult"],
	rejectTrialRequest: boolean,
	updateCertificateTemplate: GraphQLTypes["CertificateTemplateModel"],
	deleteFile: boolean,
	uploadPreSignedUrl: GraphQLTypes["UploadPreSignedUrl"],
	confirmUpload: boolean,
	acknowledgeStatsNotice: GraphQLTypes["StatsNotice"],
	createOrganization: GraphQLTypes["OrganizationModel"],
	setOrganizationStatus: GraphQLTypes["OrganizationModel"],
	updateOrganization: GraphQLTypes["OrganizationModel"],
	deleteOrganization: boolean,
	inviteOrgMember: GraphQLTypes["OrgMemberModel"],
	removeOrgMember: boolean,
	updateReminderSettings: GraphQLTypes["ReminderSettingsModel"],
	sendReminderTest: GraphQLTypes["ReminderTestResultModel"],
	['...on Mutation']: Omit<GraphQLTypes["Mutation"], "...on Mutation">
};
	["UpdateAppConfigInput"]: {
		appName?: string | undefined | null,
	logo?: string | undefined | null,
	favicon?: string | undefined | null,
	primaryColor?: string | undefined | null,
	accentColor?: string | undefined | null,
	headingFont?: string | undefined | null,
	bodyFont?: string | undefined | null,
	footerText?: string | undefined | null,
	defaultLocale?: string | undefined | null
};
	["UpdateBillingProfileInput"]: {
		companyName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	postalCode?: string | undefined | null,
	city?: string | undefined | null,
	country?: string | undefined | null,
	vatNumber?: string | undefined | null,
	billingEmail?: string | undefined | null
};
	["ChangeBillingPlanInput"]: {
		tier: GraphQLTypes["BillingTier"],
	paymentTerm?: GraphQLTypes["BillingPaymentTerm"] | undefined | null
};
	["AuthType"]:{
        	__typename:"UserInfo" | "CustomError"
        	['...on UserInfo']: '__union' & GraphQLTypes["UserInfo"];
	['...on CustomError']: '__union' & GraphQLTypes["CustomError"];
};
	["CustomError"]: {
	__typename: "CustomError",
	error: GraphQLTypes["EError"],
	message: string,
	['...on CustomError']: Omit<GraphQLTypes["CustomError"], "...on CustomError">
};
	["EError"]: EError;
	["CreateUserInput"]: {
		email: string,
	password?: string | undefined | null,
	firstName: string,
	lastName: string,
	roleId: string,
	group?: string | undefined | null
};
	["ImportUserInput"]: {
		email: string,
	firstName: string,
	lastName: string,
	group?: string | undefined | null
};
	["UpdateUserInput"]: {
		email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: string | undefined | null,
	id: string
};
	["CreateGroupInput"]: {
		name: string,
	description?: string | undefined | null,
	userIds?: Array<GraphQLTypes["ID"]> | undefined | null
};
	["UpdateGroupInput"]: {
		name?: string | undefined | null,
	description?: string | undefined | null,
	userIds?: Array<GraphQLTypes["ID"]> | undefined | null
};
	["UpsertSsoProviderInput"]: {
		kind: GraphQLTypes["SsoProviderKind"],
	label?: string | undefined | null,
	enabled?: boolean | undefined | null,
	issuer?: string | undefined | null,
	clientId?: string | undefined | null,
	clientSecret?: string | undefined | null,
	entryPoint?: string | undefined | null,
	idpIssuer?: string | undefined | null,
	idpCert?: string | undefined | null,
	allowedDomains?: Array<string> | undefined | null
};
	["UpsertScormTrackingInput"]: {
		sessionId: GraphQLTypes["ID"],
	moduleId?: GraphQLTypes["ID"] | undefined | null,
	completionStatus?: GraphQLTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: GraphQLTypes["ScormSuccessStatus"] | undefined | null,
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null
};
	["CreateSessionInput"]: {
		name: string,
	modules: Array<GraphQLTypes["SessionModuleInput"]>,
	progressionMode?: GraphQLTypes["SessionProgressionMode"] | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	userIds?: Array<GraphQLTypes["ID"]> | undefined | null
};
	["SessionModuleInput"]: {
		moduleId: GraphQLTypes["ID"],
	/** Jour civil au format AAAA-MM-JJ */
	unlockAt?: string | undefined | null
};
	["UpdateSessionInput"]: {
		name?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	startDate?: string | undefined | null,
	/** Jour civil au format AAAA-MM-JJ */
	endDate?: string | undefined | null,
	status?: GraphQLTypes["SessionStatus"] | undefined | null,
	progressionMode?: GraphQLTypes["SessionProgressionMode"] | undefined | null,
	modules?: Array<GraphQLTypes["SessionModuleInput"]> | undefined | null,
	userIds?: Array<GraphQLTypes["ID"]> | undefined | null
};
	["RequestTrialInput"]: {
		email: string,
	firstName: string,
	lastName: string,
	orgName: string,
	phone?: string | undefined | null,
	jobTitle?: string | undefined | null
};
	["UpdateCertificateTemplateInput"]: {
		title?: string | undefined | null,
	body?: string | undefined | null,
	signature?: string | undefined | null,
	showScore?: boolean | undefined | null,
	showDate?: boolean | undefined | null,
	showTotalTime?: boolean | undefined | null,
	logo?: string | undefined | null,
	orientation?: GraphQLTypes["CertificateOrientation"] | undefined | null,
	skeletonPdf?: string | undefined | null,
	marginTop?: number | undefined | null,
	marginBottom?: number | undefined | null,
	marginLeft?: number | undefined | null,
	marginRight?: number | undefined | null
};
	["CreateOrganizationInput"]: {
		name: string,
	slug: string,
	adminEmail: string,
	adminFirstName: string,
	adminLastName: string
};
	["UpdateOrganizationInput"]: {
		id: GraphQLTypes["ID"],
	name?: string | undefined | null,
	slug?: string | undefined | null,
	status?: GraphQLTypes["OrganizationStatus"] | undefined | null
};
	["InviteOrgMemberInput"]: {
		orgId: GraphQLTypes["ID"],
	email: string,
	firstName: string,
	lastName: string,
	role: GraphQLTypes["RoleEnum"]
};
	["UpdateReminderSettingsInput"]: {
		enabled?: boolean | undefined | null,
	firstDelayDays?: number | undefined | null,
	frequencyDays?: number | undefined | null,
	maxReminders?: number | undefined | null,
	sendHour?: number | undefined | null,
	subject?: string | undefined | null,
	body?: string | undefined | null
};
	["Subscription"]: {
	__typename: "Subscription",
	basicSubscription?: string | undefined | null,
	['...on Subscription']: Omit<GraphQLTypes["Subscription"], "...on Subscription">
};
	["ID"]: "scalar" & { name: "ID" }
    }
export enum AccountStatus {
	PENDING_ACTIVATION = "PENDING_ACTIVATION",
	ENABLED = "ENABLED",
	DISABLED = "DISABLED"
}
export enum UserProgress {
	NOT_STARTED = "NOT_STARTED",
	IN_PROGRESS = "IN_PROGRESS",
	COMPLETED = "COMPLETED"
}
export enum BillingTier {
	FREE = "FREE",
	S = "S",
	M = "M",
	L = "L",
	XL = "XL",
	CUSTOM = "CUSTOM"
}
export enum BillingPaymentTerm {
	UPFRONT = "UPFRONT",
	MONTHLY = "MONTHLY"
}
export enum RoleEnum {
	SuperAdmin = "SuperAdmin",
	Admin = "Admin",
	Formateur = "Formateur",
	User = "User",
	Guest = "Guest"
}
export enum CertificateOrientation {
	LANDSCAPE = "LANDSCAPE",
	PORTRAIT = "PORTRAIT"
}
export enum OrganizationStatus {
	ACTIVE = "ACTIVE",
	SUSPENDED = "SUSPENDED"
}
export enum ScormModuleStatus {
	PROCESSING = "PROCESSING",
	READY = "READY",
	FAILED = "FAILED"
}
export enum ScormCompletionStatus {
	COMPLETED = "COMPLETED",
	INCOMPLETE = "INCOMPLETE",
	NOT_ATTEMPTED = "NOT_ATTEMPTED",
	UNKNOWN = "UNKNOWN"
}
export enum ScormSuccessStatus {
	PASSED = "PASSED",
	FAILED = "FAILED",
	UNKNOWN = "UNKNOWN"
}
/** Pourquoi un module est fermé — une date à attendre, ou un module à finir. */
export enum ModuleLockReason {
	OPEN = "OPEN",
	SCHEDULED = "SCHEDULED",
	AWAITING_PREVIOUS = "AWAITING_PREVIOUS"
}
export enum SessionStatus {
	ACTIVE = "ACTIVE",
	ARCHIVED = "ARCHIVED"
}
/** Règle d'enchaînement du parcours. Le déblocage par date n'est pas une valeur ici : c'est un second verrou, porté par SessionModule.unlockAt. */
export enum SessionProgressionMode {
	FREE = "FREE",
	SEQUENTIAL = "SEQUENTIAL"
}
export enum TrialReviewStatus {
	PENDING = "PENDING",
	APPROVED = "APPROVED",
	REJECTED = "REJECTED"
}
/** Fournisseur d'identité pré-listé (#40). */
export enum SsoProviderKind {
	ENTRA_ID = "ENTRA_ID",
	GOOGLE = "GOOGLE",
	OKTA = "OKTA",
	OIDC = "OIDC",
	SAML = "SAML"
}
export enum ConsentStatus {
	PENDING = "PENDING",
	GRANTED = "GRANTED",
	DENIED = "DENIED",
	ACKNOWLEDGED = "ACKNOWLEDGED"
}
export enum OrderByEnum {
	ASC = "ASC",
	DESC = "DESC"
}
export enum EError {
	AUTH = "AUTH"
}

type ZEUS_VARIABLES = {
	["DateTime"]: ValueTypes["DateTime"];
	["AccountStatus"]: ValueTypes["AccountStatus"];
	["UserProgress"]: ValueTypes["UserProgress"];
	["BillingTier"]: ValueTypes["BillingTier"];
	["BillingPaymentTerm"]: ValueTypes["BillingPaymentTerm"];
	["RoleEnum"]: ValueTypes["RoleEnum"];
	["CertificateOrientation"]: ValueTypes["CertificateOrientation"];
	["OrganizationStatus"]: ValueTypes["OrganizationStatus"];
	["ScormModuleStatus"]: ValueTypes["ScormModuleStatus"];
	["ScormCompletionStatus"]: ValueTypes["ScormCompletionStatus"];
	["ScormSuccessStatus"]: ValueTypes["ScormSuccessStatus"];
	["ModuleLockReason"]: ValueTypes["ModuleLockReason"];
	["SessionStatus"]: ValueTypes["SessionStatus"];
	["SessionProgressionMode"]: ValueTypes["SessionProgressionMode"];
	["TrialReviewStatus"]: ValueTypes["TrialReviewStatus"];
	["SsoProviderKind"]: ValueTypes["SsoProviderKind"];
	["ConsentStatus"]: ValueTypes["ConsentStatus"];
	["FindManyUserWithFiltersInput"]: ValueTypes["FindManyUserWithFiltersInput"];
	["UserOrderByInput"]: ValueTypes["UserOrderByInput"];
	["OrderByEnum"]: ValueTypes["OrderByEnum"];
	["UserFilterByInput"]: ValueTypes["UserFilterByInput"];
	["FindManyScormTrackingWithFiltersInput"]: ValueTypes["FindManyScormTrackingWithFiltersInput"];
	["ScormTrackingOrderByInput"]: ValueTypes["ScormTrackingOrderByInput"];
	["ScormTrackingFilterByInput"]: ValueTypes["ScormTrackingFilterByInput"];
	["ScormTrackingStatsInput"]: ValueTypes["ScormTrackingStatsInput"];
	["ScormStatsScopeInput"]: ValueTypes["ScormStatsScopeInput"];
	["UpdateAppConfigInput"]: ValueTypes["UpdateAppConfigInput"];
	["UpdateBillingProfileInput"]: ValueTypes["UpdateBillingProfileInput"];
	["ChangeBillingPlanInput"]: ValueTypes["ChangeBillingPlanInput"];
	["EError"]: ValueTypes["EError"];
	["CreateUserInput"]: ValueTypes["CreateUserInput"];
	["ImportUserInput"]: ValueTypes["ImportUserInput"];
	["UpdateUserInput"]: ValueTypes["UpdateUserInput"];
	["CreateGroupInput"]: ValueTypes["CreateGroupInput"];
	["UpdateGroupInput"]: ValueTypes["UpdateGroupInput"];
	["UpsertSsoProviderInput"]: ValueTypes["UpsertSsoProviderInput"];
	["UpsertScormTrackingInput"]: ValueTypes["UpsertScormTrackingInput"];
	["CreateSessionInput"]: ValueTypes["CreateSessionInput"];
	["SessionModuleInput"]: ValueTypes["SessionModuleInput"];
	["UpdateSessionInput"]: ValueTypes["UpdateSessionInput"];
	["RequestTrialInput"]: ValueTypes["RequestTrialInput"];
	["UpdateCertificateTemplateInput"]: ValueTypes["UpdateCertificateTemplateInput"];
	["CreateOrganizationInput"]: ValueTypes["CreateOrganizationInput"];
	["UpdateOrganizationInput"]: ValueTypes["UpdateOrganizationInput"];
	["InviteOrgMemberInput"]: ValueTypes["InviteOrgMemberInput"];
	["UpdateReminderSettingsInput"]: ValueTypes["UpdateReminderSettingsInput"];
	["ID"]: ValueTypes["ID"];
}